"use strict";

var _this = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var w = window;
w.pgm = "(min-width: 450px)";
w.msm = "(max-width: 1059px)";
w.legacy = '';
w.clickedButton;
w.tabsApplied = false;
w.st = 0;
w.ap = Array.prototype;
var cver = '2';
var de = document.documentElement;
var raf = window.requestAnimationFrame;
var idl = window.requestIdleCallback;

// Testing for need for camelCase conversion
var cTest = new RegExp(/[- ]/);
// Short hand way to get data attributes cross browser
w.ds = function (n, s, v) {
  if (v || v === 0) {
    if (n.dataset) {
      n.dataset[cTest.test(s) ? camelize(s) : s] = v;
    } else {
      n.setAttribute('data-' + s, v);
    }
  } else {
    if (n.dataset) {
      return n.dataset[cTest.test(s) ? camelize(s) : s];
    } else {
      return n.getAttribute('data-' + s);
    }
  }
};
//Short hand for query selector
w.qs = function (s, p) {
  if (p) {
    return p.querySelector(s);
  } else {
    return document.querySelector(s);
  }
};
//Short hand for querySelectorAll
w.qa = function (s, p) {
  if (p) {
    return p.querySelectorAll(s);
  } else {
    return document.querySelectorAll(s);
  }
};
//Short hand for for each
w.fe = function (arr, iterate) {
  ap.forEach.call(arr, iterate);
};
//Converting camelcase to the format the site uses for category filters
var camelize = function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '').replace(/--/g, '~').replace(/-$/g, '~').replace(/-/g, '').replace(/~/g, '-');
};

//Checks a nodeList of images and marks them as loaded if loaded or onload, triggering the rows to reequalise if in specific parent
w.imgLoadEvents = function (imgs) {
  fe(imgs, function (a) {
    if (typeof a.naturalWidth == 'number' && typeof a.naturalHeight == 'number' && !(a.naturalWidth == 0 && a.naturalHeight == 0) || a.complete || a.src.indexOf('.svg') > -1) {
      a.classList.add('loaded');
    } else {
      a.addEventListener('load', function () {
        a.classList.add('loaded');
      });
    }
  });
};
w.populateBasket = function (data) {
  if (data.basket && data.basket !== null || data.quote && data.quote !== null && data.quote.item_count > 0) {
    var total_incvat = data.basket ? data.basket.total_incvat ? data.basket.total_incvat : data.basket.total : 0;
    var total_excvat = data.basket ? data.basket.total_exvat ? data.basket.total_exvat : data.basket.subtotal : 0;
    var itemCount = data.basket ? data.basket.item_count ? data.basket.item_count : data.basket.items.length : 0;
    var mb = '<span class="baskethead headlink" ';
    if (data.basket) {
      mb += 'title="&pound;' + currencyPad(total_incvat) + ' inc. VAT, &pound;' + currencyPad(total_excvat) + ' ex. VAT "';
    }
    mb += '><a href="/shop/basket/" class="iconholder">';
    if (data.basket) {
      mb += '<span class="basketcorner">' + itemCount + '</span>';
    }
    mb += '<span class="icon-basket icon"><span>Basket</span></span><span class="basketlabel">Your Basket</span></a><span class="hovercontent">';
    if (data.basket) {
      mb += '<span class="items">' + itemCount + '&nbsp;Item' + (itemCount > 1 ? 's' : '') + ' in your Basket</span>';
      mb += '<span class="totals"><strong class="big">Total: <span class="incvat">&pound;' + currencyPad(total_incvat) + ' <span class="vattag">inc. VAT</span></span><span class="exvat">&pound;' + currencyPad(total_excvat) + ' <span class="vattag">ex. VAT</span></span></strong></span>';
      mb += '<a href="/shop/basket/" class="btn">View Basket</a>&nbsp;<a href="/shop/checkout/" class="btn bbtn">Checkout</a>';
    } else {
      mb += '<a href="/products/quote.php" class="pbtn btn">View Quote</a>&nbsp;';
    }
    mb += '</span></span>';
    var bc = qs('.basketcorner');
    if (bc && data.basket) {
      bc.textContent = itemCount;
    }
    document.getElementById('mb').innerHTML = mb;
  }
};
// Runs when DOM ready
var activatePage = function activatePage() {
  // Document element dom ready class check to prevent repeats
  if (!ds(de, 'jsenabled')) {
    setTimeout(function () {
      ds(de, 'jsenabled', true);
    }, 0);
    pwrap = qs('.products_wrapper');
    imgLoadEvents(qa('img[loading="lazy"]', pwrap));
    if (typeof gapvc == 'function') {
      gapvc();
    }

    //Session features e.g. Basket and recently viewed items
    var getRecentProducts = function getRecentProducts() {
      fetch('/session.php').then(function (res) {
        return res.json();
      }).then(function (data) {
        populateBasket(data);
        if (data.compare_products && data.compare_products.length > 0) {
          fe(data.compare_products, function (s) {
            var n = qs('#comp' + s);
            if (n) {
              n.innerHTML = '<a href="/products/compare/" class="comparelink">View Compare <span class="icon-compare icon"></span></a>';
            }
          });
        }
        if (data.customer) {
          var n = qs('.wish');
          if (n) {
            n.innerHTML = '<button type="submit" name="destination" value="wishlist" class="textbutton add_wishlist wishlist_loggedin" data-value="wishlist" id="wishlist_basket" onclick="clickedButton=\'wishlist_basket\';" >Wishlist <span class="icon-heart-o icon"></span></button>';
          }
        }
        if (data.business && data.business.phone_line) {
          var ot = data.business.phone_line;
          var hoursMessage = qs("#openhours");
          var phoneNumberNode = qs('.phonenumber');
          var generateDateFields = function generateDateFields(d) {
            var month = '' + (d.getMonth() + 1);
            var day = '' + d.getDate();
            var year = d.getFullYear();
            if (month.length < 2) {
              month = '0' + month;
            }
            if (day.length < 2) {
              day = '0' + day;
            }
            var options = {
              weekday: 'short'
            };
            return {
              year: year,
              month: month,
              day: day,
              date: [year, month, day].join('-'),
              day3: new Intl.DateTimeFormat('en-UK', options).format(d).toUpperCase()
            };
          };
          var checkTime = function checkTime() {
            var pl = new Date();
            var dateDetails = generateDateFields(pl);
            var openSplit = ot.regular_hours.open.split(':');
            var closeSplit = ot.regular_hours.close.split(':');
            var open = false;
            if (ot.regular_hours.days.indexOf(dateDetails.day3) > -1 && ot.closed_dates.indexOf(dateDetails.date) == -1) {
              if ((pl.getHours() > Number(openSplit[0]) || pl.getHours() == Number(openSplit[0]) && pl.getMinutes() > Number(openSplit[1])) && (pl.getHours() < Number(closeSplit[0]) || pl.getHours() == Number(closeSplit[0]) && pl.getMinutes() < Number(closeSplit[1]))) {
                open = true;
              }
            }
            if (open) {
              hoursMessage.innerHTML = "We are <strong class='normal'>open</strong>, we close at " + ot.regular_hours.close + '.<br />Call us:';
              phoneNumberNode.classList.remove('disabled');
            } else {
              var newText = "We are <strong class='normal'>closed</strong>, we open again ";
              var nextOpen = new Date();
              nextOpen.setTime(pl.getTime());
              var daysCount = 0;
              if (pl.getHours() > Number(closeSplit[0]) || pl.getHours() == Number(closeSplit[0]) && pl.getMinutes() > Number(closeSplit[1])) {
                nextOpen.setTime(nextOpen.getTime() + 86400000);
                daysCount = 1;
              }
              var nextDetails = generateDateFields(nextOpen);
              while ((ot.regular_hours.days.indexOf(nextDetails.day3) == -1 || ot.closed_dates.indexOf(nextDetails.date) > -1) && daysCount < 14) {
                nextOpen.setTime(nextOpen.getTime() + 86400000);
                nextDetails = generateDateFields(nextOpen);
                daysCount++;
              }
              if (daysCount < 14) {
                if (nextDetails.date == dateDetails.date) {
                  if (nextOpen.getHours() < Number(openSplit[0]) || nextOpen.getHours() == Number(openSplit[0]) && nextOpen.getMinutes() < Number(openSplit[1])) {
                    newText += "at " + ot.regular_hours.open;
                  }
                }
                if (nextDetails.date != dateDetails.date) {
                  var dayoptions = {
                    weekday: 'long'
                  };
                  newText += (daysCount == 1 ? 'Tomorrow' : new Intl.DateTimeFormat('en-UK', dayoptions).format(nextOpen)) + " at " + ot.regular_hours.open;
                }
                if (Intl.DateTimeFormat().resolvedOptions().timeZone.indexOf('London') == -1) {
                  newText += ' UK Time';
                }
                hoursMessage.innerHTML = newText + '.<br />Our number is:';
                if (!phoneNumberNode.classList.contains('disabled')) {
                  phoneNumberNode.classList.add('disabled');
                }
              }
            }
          };
          if (hoursMessage) {
            checkTime();
            setInterval(checkTime, 60000);
          }
        }
        if (data.recently_viewed_products && data.recently_viewed_products.length > 0) {
          loadJS(asc + '/shop/js/recent-bundle.js?a', function () {
            var ri = qs('#recentitems');
            if (ri) {
              if (ri.offsetTop > window.scrollY + window.innerHeight) {
                displayRecent(ri, data.recently_viewed_products);
              } else {
                var loadRi = document.createElement('div');
                loadRi.className = 'loadRi';
                loadRi.setAttribute('role', 'link');
                loadRi.textContent = 'Recently Viewed Items';
                ri.appendChild(loadRi);
                loadRi.addEventListener('click', function () {
                  displayRecent(ri, data.recently_viewed_products);
                });
              }
            }
          });
        }
      });
    };
    if (idl) idl(function () {
      window.setTimeout(getRecentProducts, 0);
    });else window.addEventListener('load', getRecentProducts);

    //Cookie notifications
    var cookienotified = document.cookie.match(/cookienotified=([^;]+)/);
    var cnv = cookienotified ? cookienotified[1].match(/^([\d.]+),[0,1],[0,1](,[0,1])?$/) : false;
    if (!cookienotified || cookienotified[1] == 'yes' || cnv && cnv[1] != cver) {
      if (location.href.indexOf('privacy-policy') > -1) {
        if (cookienotified) {
          cprefs = cookienotified[1].split(',');
          if (cprefs[1] == '1') {
            gtag('consent', 'update', {
              'analytics_storage': 'granted'
            });
            window.uetq.push('consent', 'update', {
              'ad_storage': 'granted'
            });
          }
          if (cprefs.length > 3 && cprefs[3] == '1') {
            gtag('consent', 'update', {
              'ad_storage': 'granted',
              'ad_user_data': 'granted',
              'ad_personalization': 'granted'
            });
          }
        }
        displaycookiePrefs();
      } else {
        if (location.href.indexOf('?nocookie') === -1) {
          var cb = document.createElement('div');
          cb.className = 'cookiebar';
          cb.innerHTML = '<div><p class="h3"><strong>Select Cookie Preferences</strong></h3><p>This site uses cookies, while some are necessary for the site to work, you can choose to decline optional cookies. However some website features, like our live chat service, will disabled if you do this. For more details see our <a href="/privacy-policy#cookies">Cookie Policy</a></p><button type="button" class="btn gbtn" id="creject">Reject</button> <button type="button" class="btn gbtn" id="ccustomise">Options</button> <button type="button" class="btn bbtn" id="removeCB">Accept All</button></div>';
          var h = qs('body');
          h.insertBefore(cb, h.firstChild);
          document.getElementById('ccustomise').addEventListener('click', function () {
            displaycookiePrefs();
          });
          document.getElementById('creject').addEventListener('click', function () {
            cprefs = [cver, '0', '0', '0'];
            document.cookie = "cookienotified=" + cver + ",0,0,0; path=/; expires=Thu, 31 Dec 2099 23:59:59;samesite=lax";
            cb.parentNode.removeChild(cb);
            gtag('consent', 'update', {
              'analytics_storage': 'denied'
            });
            window.uetq.push('consent', 'update', {
              'ad_storage': 'denied'
            });
          });
          document.getElementById('removeCB').addEventListener('click', function () {
            cprefs = [cver, '1', '1', '1'];
            document.cookie = "cookienotified=" + cver + ",1,1,1; path=/; expires=Thu, 31 Dec 2099 23:59:59;samesite=lax";
            cb.parentNode.removeChild(cb);
            if (window.pageloaded) {
              dataLayer.push([{
                event: 'page_view',
                page_title: w.document.title,
                page_location: location.href
              }]);
            }
            gtag('consent', 'update', {
              'analytics_storage': 'granted'
            });
            window.uetq.push('consent', 'update', {
              'ad_storage': 'granted'
            });
            gtag('consent', 'update', {
              'ad_storage': 'granted',
              'ad_user_data': 'granted',
              'ad_personalization': 'granted'
            });
          });
        }
      }
    } else {
      if (cookienotified) {
        cprefs = cookienotified[1].split(',');
        if (cprefs[1] == '1') {
          gtag('consent', 'update', {
            'analytics_storage': 'granted'
          });
          window.uetq.push('consent', 'update', {
            'ad_storage': 'granted'
          });
        }
        if (cprefs.length > 3 && cprefs[3] == '1') {
          gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted'
          });
        }
        if (document.getElementById('ccustom')) {
          displaycookiePrefs();
        }
      }
    }
  }

  // DOM ready horizontal scroller implementation
  var hshs = qa('.hscrollerholder');
  if (hshs.length > 0) {
    setupHScrollers(hshs);
  }

  // Selectbox links
  var slas = qa('.selectlista');
  if (slas.length > 0) {
    fe(slas, function (sla) {
      var s = createElement('select');
      s.addEventListener('change', function () {
        location.href = _this.value;
      });
      fe(qa('a', sla), function (a) {
        var o = createElement('option');
        o.setAttribute('value', a.href);
        o.textContent = a.textContent;
        s.appendChild(o);
      });
      sla.innerHTML = '';
      sla.appendChild(s);
    });
  }

  // Simple expanders
  var eh = qa('.expand_head');
  if (eh.length > 0) {
    fe(eh, function (te) {
      var body = te.nextElementSibling;
      if (!body.classList.contains('expand_body')) {
        body = te.previousElementSibling;
      }
      var lbl = qs('.label', te);
      var _closeBody = function closeBody(e) {
        if (te.classList.contains('active')) {
          var eb = e.target.closest('.expand_body');
          if (!eb || e.target.nodeName == 'A' || e.target.nodeName == 'OPTION') {
            slideUp(body);
            if (lbl) {
              lbl.textContent = 'Reveal more';
            }
            te.classList.remove('active');
            document.body.removeEventListener('click', _closeBody);
          }
        }
      };
      te.addEventListener('click', function (e) {
        e.stopPropagation();
        if (te.classList.contains('active')) {
          _closeBody(e);
        } else {
          var sel = body.closest('.select');
          if (sel) {
            var otherActive = qs('.select .expand_head.active');
            if (otherActive) {
              var oabody = otherActive.nextElementSibling;
              if (!oabody.classList.contains('expand_body')) {
                oabody = otherActive.previousElementSibling;
              }
              oabody.style.display = '';
              var oalbl = qs('.label', otherActive);
              if (oalbl) {
                oalbl.textContent = 'Reveal more';
              }
              otherActive.classList.remove('active');
            }
          }
          slideDown(body);
          if (sel) {
            var bsh = body.scrollHeight;
            var ehpos = te.getBoundingClientRect();
            if (window.innerHeight < ehpos.bottom + bsh && ehpos.top > bsh) {
              te.parentNode.classList.add('up');
            } else {
              te.parentNode.classList.remove('up');
            }
            document.body.addEventListener('click', _closeBody);
          }
          if (lbl) {
            lbl.textContent = 'Hide';
          }
          te.classList.add('active');
        }
      });
      if (!te.classList.contains('active')) {
        body.style.display = 'none';
      }
    });
  }

  //Seach input auto complete
  initAutoSearch(document.getElementById("search"));

  // Lease popup
  var bpage = qs('.basketpage');
  if (bpage) {
    var obtn = qs(' .btn.obtn.disabled');
    if (obtn) {
      loadJS(asc + '/shop/js/lease-pop-bundle.js', function () {
        obtn.addEventListener('click', addLeasePop);
      });
    }
  }

  //Fancybox replacement (cabox) call in if needed
  if (qs('.fancylink,.fancytrustwave,jspopup,.ufancylink,.fancytour')) {
    var activatePopFunctions = function activatePopFunctions() {
      if (w.caboxPoppedFunctions) {
        for (var i = 0; i < w.caboxPoppedFunctions.length; i++) {
          w.caboxPoppedFunctions[i]();
        }
      }
    };
    cabox.init('.fancylink', {
      onComplete: activatePopFunctions
    });
    cabox.init('.fancytrustwave', {
      type: 'iframe',
      width: 590,
      height: 517
    });
    cabox.init('.fancytour', {
      type: 'iframe',
      width: 1100,
      height: 640
    });
    var ufancyboxes = qa('.ufancylink');
    if (ufancyboxes.length > 0) {
      fe(ufancyboxes, function (l, i) {
        l.classList.add('ufb' + i);
        if (w.ds(l, 'width')) {
          cabox.init('.ufb' + i, {
            onComplete: activatePopFunctions,
            width: w.ds(l, 'width')
          });
        } else {
          cabox.init('.ufb' + i, {
            onComplete: activatePopFunctions
          });
        }
      });
    }
  }

  // Categories subnav
  var ne = qs('#navexpander');
  var nav = qs('#nav');
  if (ne) {
    fe(qa('.dl', ne), function (a) {
      a.addEventListener('click', function (e) {
        if (!a.parentNode.classList.contains('active')) {
          var l = ds(a, 'list');
          var t = qs('#navexpanderlist' + l);
          var old = qs('#navexpander > li.active');
          if (old) {
            var oldDrop = qs('.drop', old);
            if (oldDrop) {
              oldDrop.classList.remove("slideDown");
              oldDrop.classList.add('slideUp');
              var _removeActive = function removeActive() {
                old.classList.remove('slideUp');
                oldDrop.removeEventListener('animationend', _removeActive);
              };
              oldDrop.addEventListener('animationend', _removeActive);
            }
            old.classList.remove('active');
          }
          a.parentNode.classList.add('active');
          if (!t.classList.contains("slideDown")) {
            var v = ap.filter.call(t.parentNode.children, function (c) {
              return c != t && c.offsetHeight > 0 && c.className == 'drop';
            });
            if (v.length > 0) {
              fe(v, function (n, i) {
                t.classList.remove("slideDown");
              });
              setTimeout(function () {
                t.classList.add("slideDown");
              }, 100);
              var oa = qs('.active', a.parentNode.parentNode);
              if (oa) {
                oa.classList.remove('active');
              }
            } else {
              t.classList.add("slideDown");
            }
            fe(t.parentNode.parentNode.children, function (c) {
              if (c && c != t.parentNode && c.classList.contains('active')) {
                c.classList.remove('active');
              }
            });
          }
          e.preventDefault();
          nav.classList.add('on');
        }
      });
    });
    fe(qa('.drop', ne), function (a, i) {
      a.id = 'navexpanderlist' + i;
      var s = Array.prototype.filter.call(a.parentNode.children, function (child) {
        return child !== a && child.nodeName == 'A';
      })[0];
      ds(s, 'list', i);
      /*const icon = document.createElement('div');
      icon.className = "icon nostockicon";
      icon.addEventListener('click',() => {
          slideUp(a);
          fe(qa('#navexpander .active'), n => {
              n.classList.remove('active');
          });
      });
      const c = qs('.container',a);
      c.insertBefore(icon, c.firstChild);
      a.style.display = 'none';*/
    });
  }

  //Animated scrolling in page links
  fe(qa('.smoothscroll'), function (a) {
    a.addEventListener('click', function (e) {
      if (a.href.indexOf('#') > -1) {
        var hsh = a.href.split('#')[1];
        if (document.getElementById(hsh)) {
          scrollToSel('#' + hsh);
          history.pushState({}, '', '#' + hsh);
          if (e) {
            e.preventDefault();
          }
          return false;
        }
      }
    });
  });

  //Resize throttling

  setTimeout(function () {
    window.addEventListener('resize', throttle(initMobile, 250));
    initMobile();
  }, 10);

  // incvat exvat switcher
  var b = document.body;
  if (cookievat && cookievat.length > 0) {
    b.className = b.className.replace(new RegExp('(ex|in)cvat', 'g'), '');
    b.classList.add(cookievat[1]);
  } else {
    b.classList.remove('excvat');
    b.classList.add('incvat');
  }
  var vs = document.getElementById('vatswitcher');
  if (vs) {
    vs.innerHTML = '<p>Show prices: <label for="incvat">inc. VAT <input type="radio" name="vat" id="incvat" value="incvat" /></label> <label for="excvat">ex. VAT <input type="radio" name="vat" id="excvat" value="excvat" /></label></p>';
    if (cookievat && cookievat.length > 0) {
      qs("#".concat(cookievat[1])).setAttribute('checked', true);
    } else {
      qs('#incvat').setAttribute('checked', true);
    }
    fe(qa('input', vs), function (i) {
      i.addEventListener('change', function (a) {
        b.className = b.className.replace(new RegExp('(ex|in)cvat', 'g'), '');
        b.classList.add(a.value);
        document.cookie = 'cookievat=' + _this.value + ';path=/;samesite=lax';
        if (dataLayer) {
          dataLayer.push({
            event: 'vat_switch',
            value: a.value
          });
        }
        var oa = qs('#optionsaccessories');
        if (oa) {
          fe(qs('option', oa), function (o) {
            if (ds(oa, 'name')) {
              if (b.classList.contains('incvat')) {
                o.innerHTML = "".concat(ds(oa, 'name'), " + &pound;").concat(currencyPad(ds(o, 'vatprice')));
              } else {
                o.innerHTML = "".concat(ds(oa, 'name'), " + &pound;").concat(currencyPad(ds(o, 'price')));
              }
            }
          });
          refreshProductPrices();
        }
      });
    });
  }
  fe(qa('.offer, .product_price, td.price, .a_p, .vat_switch_holder, .vat_status'), function (n) {
    n.addEventListener('click', vatSwitcher);
  });
  if (qs('.vat_container')) {
    var dragging;
    fe(window.proddata ? qa('.vat_switch_back') : [qs('.vat_switch_back', vs)], function (bar) {
      var sh = qs('.vat_switch', bar);
      var startX;
      var vstart = function vstart(e) {
        startX = e.pageX;
        if (!startX) {
          var touch = e.touches[0] || e.changedTouches[0];
          startX = touch.pageX;
        }
        dragging = true;
        e.stopPropagation();
        return false;
      };
      var vend = function vend(e) {
        var wasDragging = dragging;
        dragging = false;
        var x = e.pageX;
        if (!x && e) {
          if (e.touches) {
            var touch = e.touches[0] || e.changedTouches[0];
            x = touch.pageX;
          } else {
            x = 0;
          }
        }
        var barpos = bar.getBoundingClientRect();
        var shpos = sh.getBoundingClientRect();
        if (typeof startX != 'undefined' && startX != x && wasDragging) {
          if (shpos.left < barpos.left + (bar.offsetWidth - sh.offsetWidth) / 2) {
            activateExcVat();
          } else {
            activateIncVat();
          }
        } else {
          if (shpos.left < barpos.left + (bar.offsetWidth - sh.offsetWidth) / 2) {
            activateIncVat();
          } else {
            activateExcVat();
          }
        }
        Object.assign(sh.style, {
          left: '',
          transform: '',
          transition: ''
        });
        startX = false;
        return false;
      };
      var vmove = function vmove(e) {
        if (dragging) {
          var x = e.pageX;
          if (!x) {
            var touch = e.touches[0] || e.changedTouches[0];
            x = touch.pageX;
          }
          var barpos = bar.getBoundingClientRect();
          var target = Math.min(x - barpos.left, bar.offsetWidth) / bar.offsetWidth;
          if (target <= 0) {
            target = 0;
          } else if (target >= 1) {
            target = 1;
          }
          if (target < 0.5) {
            activateExcVat();
          } else {
            activateIncVat();
          }
          Object.assign(sh.style, {
            'left': target * 100 + '%',
            'transform': 'translate(-' + target * 100 + '%,0)',
            transition: 'none'
          });
        }
      };
      sh.addEventListener('mousedown', vstart);
      sh.addEventListener('touchstart', vstart, {
        passive: true
      });
      bar.addEventListener('mouseout', function (e) {
        if (dragging) {
          var evt = document.createEvent("MouseEvents");
          evt.initEvent("mouseup", true, true);
          e.target.dispatchEvent(evt);
        }
      });
      bar.addEventListener('mouseup', vend);
      bar.addEventListener('touchend', vend);
      bar.addEventListener('mousemove', vmove);
      bar.addEventListener('touchmove', vmove, {
        passive: true
      });
      bar.addEventListener('click', function () {
        return false;
      });
    });
  }

  // Expander styles
  var aeh = qa('.expander_head');
  if (aeh.length > 0) {
    fe(aeh, function (h) {
      var eb = qs('.expander_body', h.parentNode);
      h.addEventListener('click', function () {
        if (eb.offsetHeight > 0) {
          h.classList.remove('active');
          slideUp(eb);
        } else {
          h.classList.add('active');
          slideDown(eb);
        }
      });
      if (!h.classList.contains('active')) {
        eb.style.display = 'none';
      }
    });
  }

  //Styles select boxes (checkout)
  var radios = qa('.radio input');
  if (radios.length > 0) {
    fe(radios, function (n) {
      n.addEventListener('change', function () {
        if (n.checked) {
          fe(radios, function (r) {
            if (r.name == n.name && r.value != r.value) {
              qs('.radiostatus', r.parentNode).textContent = 'Select';
            }
          });
          qs('.radiostatus', n.parentNode).textContent = 'Selected';
        }
      });
      if (n.checked) {
        qs('.radiostatus', n.parentNode).textContent = 'Selected';
      }
    });
  }

  //Dynamically load includes and sticky scroll styles
  var dloads = qa('.dLoad');
  var loader = document.createElement('div');
  loader.className = 'loaderholder';
  loader.innerHTML = '<div class="loader"></div>';
  var categoryData = [];
  var called = [];
  var lastHovered = null;
  var catChildrenHTML = function catChildrenHTML(catdata) {
    if (catdata.children) {
      return "".concat(catdata.children.map(function (c, i) {
        if (c.num_listed_products > 0 || !c.children || c.children && c.children.length > 0) {
          return "<li><a draggable=\"false\" title=\"".concat(c.name, "\" href=\"").concat(c.url, "\" data-id=\"").concat(c.id, "\"").concat(c.children && c.children.length > 0 ? 'class="hasChildren"' : '', ">").concat(c.name, "</span></a></li>");
        } else {
          return '';
        }
      }).join(''));
    }
  };
  var navcontroller;
  var _overCat = function overCat(e) {
    if (!e.target.parentNode.classList.contains('active') && e.target.classList.contains('hasChildren')) {
      e.preventDefault();
      if (e.type == 'mouseenter' && !window.matchMedia(msm).matches || e.type == 'click' && window.matchMedia(msm).matches) {
        var a = e.target;
        var id = ds(a, 'id');
        var catDataIndex = categoryData.findIndex(function (d) {
          return d.id == id;
        });
        var ul = a.closest('.ul');
        while (ul.nextElementSibling) {
          ul.nextElementSibling.remove();
        }
        var last = qs('.active', ul);
        if (last) {
          last.classList.remove('active');
        }
        a.parentNode.classList.add('active');
        if (catDataIndex > -1) {
          if (categoryData[catDataIndex].children && categoryData[catDataIndex].children.length > 0) {
            var nextul = document.createElement('div');
            nextul.classList.add('ul');
            nextul.innerHTML = "<div class=\"scrlup\"></div><ul>".concat(catChildrenHTML(categoryData[catDataIndex]), "</ul><div class=\"scrldn\"></div>");
            if (!window.matchMedia(msm).matches) {
              ul.after(nextul);
            } else {
              a.after(nextul);
            }
            lastHovered = {
              id: Number(id),
              event: e
            };
            setupCatNavLinks(nextul);
          }
          if (categoryData[catDataIndex].children && categoryData[catDataIndex].children.length > 0) {
            var ids = categoryData[catDataIndex].children.map(function (c) {
              return c.id;
            }).join(',');
            if (navcontroller) {
              navcontroller.abort('Operation cancelled by the user');
            }
            navcontroller = new AbortController();
            if (called.indexOf(ids) == -1) {
              fetch("/api/nav/categories?root=".concat(ids, "&md=1"), {
                signal: navcontroller.signal
              }).then(function (res) {
                return res.json();
              }).then(function (data) {
                called.push(ids);
                categoryData[catDataIndex].children = data.categories;
                fe(data.categories, function (c, i) {
                  var catDataIndex = categoryData.findIndex(function (d) {
                    return d.id == c.id;
                  });
                  if (catDataIndex > -1) {
                    categoryData[catDataIndex] = c;
                  } else {
                    categoryData.push(c);
                  }
                  if (c.id == lastHovered.id) {
                    _overCat(lastHovered.event);
                  }
                  if (c.children.length > 0) {
                    var ida = qs("a[data-id=\"".concat(c.id, "\"]"), ul.parentNode);
                    if (!ida.classList.contains('hasChildren')) {
                      ida.classList.add('hasChildren');
                    }
                    fe(c.children, function (cc) {
                      var catDataIndex = categoryData.findIndex(function (d) {
                        return d.id == cc.id;
                      });
                      if (catDataIndex > -1) {
                        categoryData[catDataIndex] = cc;
                        if (cc.children && cc.children.length > 0) {
                          called.push(cc.id);
                        }
                        if (cc.id == lastHovered.id) {
                          _overCat(lastHovered.event);
                        }
                      } else {
                        categoryData.push(cc);
                      }
                    });
                  }
                });
              })["catch"](function (e) {
                var lh = qs('.loaderholder', a.closest('.dLoad'));
                if (lh) {
                  lh.parentNode.removeChild(lh);
                }
              });
            }
          }
        } else {
          lastHovered = {
            id: id,
            event: e
          };
        }
      }
    }
  };
  var setupCatHover = function setupCatHover(nextul) {
    var cul = qs('ul', nextul);
    cul.addEventListener('scroll', throttle(function () {
      if (nextul.offsetHeight < cul.scrollHeight) {
        nextul.classList.add('scrollable');
        if (cul.scrollTop > 0) {
          nextul.classList.add('scrollableUp');
        } else {
          nextul.classList.remove('scrollableUp');
        }
        if (cul.scrollTop + nextul.offsetHeight < cul.scrollHeight) {
          nextul.classList.add('scrollableDown');
        } else {
          nextul.classList.remove('scrollableDown');
        }
      } else {
        cul.classList.remove('scrollable');
      }
    }, 250));
    triggerEvent(cul, 'scroll');
    var scrlup = qs('.scrlup', nextul);
    scrlup.addEventListener('click', function () {
      cul.scrollTo({
        top: cul.scrollTop - nextul.offsetHeight,
        behavior: 'smooth'
      });
    });
    var scrldown = qs('.scrldn', nextul);
    scrldown.addEventListener('click', function () {
      cul.scrollTo({
        top: cul.scrollTop + nextul.offsetHeight,
        behavior: 'smooth'
      });
    });
  };
  var _renderCategoryMenus = function renderCategoryMenus(categories) {
    fetch("/api/nav/categories?".concat(categories.length == 0 ? '' : "root=".concat(categories.map(function (c) {
      return c.id;
    }).join(',')), "&md=2")).then(function (res) {
      return res.json();
    }).then(function (data) {
      if (categories.length == 0) {
        categoryData = data.categories;
        fe(categoryData, function (c) {
          if (c.children && c.children.length > 0) {
            categoryData = categoryData.concat(c.children);
          }
        });
        var cat0 = qs('#cat0');
        cat0.innerHTML = "<div class=\"ul\"><div class=\"scrlup\"></div><ul>".concat(catChildrenHTML({
          children: data.categories
        }), "</ul><div class=\"scrldn\"></div></div>");
        setupCatNavLinks(cat0.children[0]);
      } else if (data.categories.length > 0) {
        fe(data.categories, function (c) {
          fe(c.children, function (cc) {
            var catDataIndex = categoryData.findIndex(function (d) {
              return d.id == cc.id;
            });
            if (catDataIndex > -1) {
              categoryData[catDataIndex] = cc;
            } else {
              categoryData.push(cc);
            }
          });
        });
      }
    })["catch"](function (e) {
      setTimeout(function () {
        _renderCategoryMenus(categories);
      }, 30);
    });
  };
  var setupCatNavLinks = function setupCatNavLinks(tgt) {
    var links = qa('a', tgt);
    fe(links, function (a) {
      var isTouched = false;
      a.addEventListener('mouseenter', _overCat);
      a.addEventListener('click', _overCat);
      a.addEventListener('touchstart', function (e) {
        isTouched = true;
      });
      a.addEventListener('click', function (e) {
        if (isTouched && e.target.classList.contains('hasChildren') && !e.target.classList.contains('clicked') || hasScrolled) {
          e.preventDefault();
        }
        e.target.classList.add('clicked');
        hasScrolled = false;
      });
    });
    setupCatHover(tgt);
    var isDown = false;
    var startY;
    var scrollTop;
    var hasScrolled = false;
    var moved = false;
    var ul = qs('ul', tgt);
    ul.addEventListener('mousedown', function (e) {
      isDown = true;
      startY = e.pageY - ul.getBoundingClientRect().top;
      scrollTop = ul.scrollTop;
    });
    ul.addEventListener('mouseleave', function (e) {
      isDown = false;
    });
    ul.addEventListener('mouseup', function (e) {
      isDown = false;
      moved = false;
      ul.classList.remove('active');
      var newY = e.pageY - ul.getBoundingClientRect().top;
    });
    ul.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var y = e.pageY - ul.getBoundingClientRect().top;
      if (y < startY - 5 || y > startY + 5) {
        e.preventDefault();
        var walk = y - startY; //scroll-fast
        ul.scrollTop = scrollTop - walk;
        hasScrolled = true;
        moved = true;
      }
    });
  };
  var gettingManufacturers = false;
  var renderManufacturerMenu = function renderManufacturerMenu(container) {
    if (container && !gettingManufacturers) {
      gettingManufacturers = true;
      fetch("/api/nav/manufacturer").then(function (res) {
        return res.json();
      }).then(function (data) {
        var loader = qs('.loaderholder', container);
        if (loader) {
          loader.parentNode.removeChild(loader);
        }
        var newcontainer = document.createElement('div');
        newcontainer.classList.add('b');
        var asseturl = data.assetbase;
        fe(data.manufacturers, function (m, i) {
          var n = document.createElement('a');
          n.href = '/' + m.url_key;
          n.innerHTML = "<picture><img class=\"product_brand\" src=\"".concat(asseturl).concat(m.brand_logo_url, "\" alt=\"").concat(m.manufacturer_name, "\" loading=\"lazy\" /></picture>");
          newcontainer.appendChild(n);
        });
        container.insertBefore(newcontainer, qs('.btn', container));
      })["catch"](function (e) {
        gettingManufacturers = false;
      });
    } else {
      var _loader = qs('.loaderholder', container);
      if (_loader) {
        _loader.parentNode.removeChild(_loader);
      }
    }
  };
  w.dynamicLoad = function (n) {
    var u = ds(n, 'url');
    if (called.indexOf(u) == -1) {
      called.push(u);
      var thisloader = loader.cloneNode(true);
      n.prepend(thisloader);
      if (u.match(/^\d+$/)) {
        _renderCategoryMenus([{
          id: u,
          node: n
        }]);
      }
      if (u.length == 0) {
        _renderCategoryMenus([]);
      } else if (u == '/api/nav/manufacturer') {
        renderManufacturerMenu(n);
      } else {
        fetch(u).then(function (res) {
          return res.text();
        }).then(function (dText) {
          fe(qa('.dLoad[data-url="' + u + '"]'), function (m) {
            if (loader.parentNode) {
              loader.parentNode.removeChild(thisloader);
            }
            var b = qs('.nostockicon', m);
            if (b) {
              m.removeChild(b);
            }
            if (u.indexOf('#') > -1) {
              var pseudo = document.createElement('div');
              pseudo.innerHTML = dText;
              var psuedosection = qs(u.substring(u.indexOf('#'), u.length), pseudo);
              if (psuedosection) {
                m.innerHTML = psuedosection.innerHTML;
              } else {
                m.innerHTML = dText;
              }
            } else {
              m.innerHTML = dText;
            }
            if (b) {
              m.insertBefore(b, m.firstChild);
            }
          });
        })["catch"](function (e) {
          console.log(e);
          var itemIndex = called.indexOf(u);
          if (itemIndex > -1) {
            called.splice(itemIndex, 1);
          }
        });
      }
    }
  };
  document.body.addEventListener('click', function (e) {
    if (e.target.nodeName !== "A" && !e.target.closest('a')) {
      var activeItem = qs('#navexpander li.active .drop');
      if (activeItem) {
        activeItem.closest('.active').classList.remove('active');
        activeItem.classList.remove('slideDown');
        activeItem.classList.add('slideUp');
        var _removeActive2 = function removeActive() {
          activeItem.classList.remove('slideUp');
          activeItem.removeEventListener('animationend', _removeActive2);
        };
        activeItem.addEventListener('animationend', _removeActive2);
      }
      nav.classList.remove('on');
    }
  });
  var imageObserver = new IntersectionObserver(function (entries, observer) {
    fe(entries, function (entry, index) {
      if (entry.isIntersecting) {
        w.dynamicLoad(entry.target);
      }
    });
  });
  fe(dloads, function (div) {
    imageObserver.observe(div);
  });
  if (!window.matchMedia(msm).matches) {
    window.addEventListener('load', function () {
      setTimeout(function () {
        var catids = [];
        fe(dloads, function (n) {
          var u = ds(n, 'url');
          if (called.indexOf(u) == -1) {
            if (u.match(/^\d+$/)) {
              catids.push({
                id: u,
                node: n
              });
              called.push(u);
            } else if (u.length == 0) {
              _renderCategoryMenus([]);
            } else if (u == '/api/nav/manufacturer') {
              renderManufacturerMenu(n);
            } else {
              w.dynamicLoad(n);
            }
          }
        });
        if (catids.length > 0) {
          _renderCategoryMenus(catids);
        }
      }, 3000);
    });
  }

  //Scroll events for sticky features
  sct = qs('#sctop');
  var ft = qs('.footer');
  var throttledScroll = function throttledScroll() {
    w.st = w.scrollY;
    if (w.st < 100) {
      if (sct.classList.contains("nottop")) {
        sct.classList.remove("nottop");
      }
    } else {
      sct.classList.add("nottop");
      w.body.classList.add("nottop");
      w.checksct();
      if (sct.getBoundingClientRect().top + 24 > ft.getBoundingClientRect().top) {
        sct.classList.add('overFooter');
      } else {
        sct.classList.remove('overFooter');
      }
    }
  };
  window.addEventListener('scroll', throttle(throttledScroll, 100));

  //Information popups
  ipopSetup('body');
  if (qs('.jspopup')) {
    var jpl = qa('.jspopuplink');
    fe(jpl, function (a) {
      a.addEventListener('click', function (e) {
        var t = a.href;
        t = t.substring(t.indexOf('#'), t.length);
        if (ds(a, 'popwidth')) {
          popDivContent(t, ds(a, 'popwidth'));
        } else {
          popDivContent(t);
        }
        if (e) {
          e.preventDefault();
        }
        return false;
      });
    });
  }
  var newsbtns = qa('.newsbtn');
  if (newsbtns.length > 0) {
    fe(newsbtns, function (n) {
      n.addEventListener('click', function (e) {
        cabox.init(null, {
          content: '<h2>Newsletter signup</h2><p>Keep up to date with our latest offers and competitions</p><form class="js-cm-form" id="subForm" action="https://www.createsend.com/t/subscribeerror?description=" method="post" data-id="A61C50BEC994754B1D79C5819EC1255CFCC0FDA5D479B98F2DB257A191DB74EA80DF57EA2D4768500D8A2919073D5E6D0EB96FF5549C1E7E4931A931EB9EAFD3"><div><div class="form-field required-field"><label>Name </label><input aria-label="Name" id="fieldName" maxlength="200" name="cm-name"></div><div class="form-field required-field"><label>Email </label><input autocomplete="Email" aria-label="Email" class="js-cm-email-input qa-input-email" id="fieldEmail" maxlength="200" name="cm-gtudid-gtudid" required="" type="email"></div></div><button class="btn" type="submit">Subscribe</button></form>',
          onComplete: function onComplete() {
            loadJS('https://js.createsend1.com/javascript/copypastesubscribeformlogic.js', document.head);
          }
        });
        e.preventDefault();
        return false;
      });
    });
  }
  var loadDeferredStyles = function loadDeferredStyles() {
    var addStylesNode = qs("#deferred-styles");
    var replacement = document.createElement("div");
    replacement.innerHTML = addStylesNode.textContent;
    while (replacement.childNodes.length > 0) {
      document.head.appendChild(replacement.childNodes[0]);
    }
    ;
    addStylesNode.parentElement.removeChild(addStylesNode);
  };
  if (idl) idl(function () {
    window.setTimeout(loadDeferredStyles, 10);
  });else window.addEventListener('load', loadDeferredStyles);
  document.body.addEventListener('keyup', function (e) {
    if (document.activeElement === document.body && e.keyCode === 191) {
      qs('#search').focus();
    }
  });
  var loadingDelayed = true;
  var stopDelay = function stopDelay() {
    if (loadingDelayed) {
      var delays = qa('.delayload');
      fe(delays, function (n) {
        n.classList.remove('delayload');
      });
      loadingDelayed = false;
    }
  };
  var mouseScroll = function mouseScroll(gallery) {
    var slider = qs('.gallery_holder', gallery);
    var isDown = false;
    var hasMoved = false;
    var startX;
    var lastX;
    var lastMove;
    var scrollLeft;
    var screentouched = false;
    window.addEventListener('touchstart', function () {
      screentouched = true;
    }, {
      passive: true
    });
    slider.addEventListener('mousedown', function (e) {
      if (!screentouched && e.button === 0) {
        isDown = true;
        hasMoved = false;
        startX = lastX = e.pageX - slider.getBoundingClientRect().left;
        lastMove = 0;
        scrollLeft = slider.scrollLeft;
      }
    });
    slider.addEventListener('mouseleave', function (e) {
      if (!screentouched && isDown) {
        endDrag(e);
      }
    });
    slider.addEventListener('mouseup', function (e) {
      if (hasMoved) {
        e.preventDefault();
        return false;
      }
    });
    slider.addEventListener('mousemove', function (e) {
      if (!screentouched) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - slider.getBoundingClientRect().left;
        var walk = x - startX; //scroll-fast
        if (Math.abs(walk) > 10) {
          if (!hasMoved) {
            hasMoved = true;
            gallery.classList.add('dragging');
            gallery.classList.add('adragging');
          } else {
            slider.scrollLeft = scrollLeft - walk;
          }
          var newX = e.pageX - slider.getBoundingClientRect().left;
          if (newX != lastX) {
            lastMove = newX - lastX;
            lastX = newX;
          }
        }
      }
    });
    slider.addEventListener('click', function (e) {
      if (!screentouched && hasMoved) {
        e.preventDefault();
        endDrag(e);
        return false;
      }
    });
    function endDrag(e) {
      isDown = false;
      if (hasMoved) {
        hasMoved = false;
        gallery.classList.remove('adragging');
        var _w = gallery.offsetWidth;
        if (lastMove < 0) {
          slider.scrollLeft = Math.floor(slider.scrollLeft / _w) * _w + _w;
        } else if (lastMove > 0) {
          slider.scrollLeft = Math.ceil(slider.scrollLeft / _w) * _w - _w;
        }
        setTimeout(function () {
          gallery.classList.remove('dragging');
        }, 500);
      }
    }
  };
  var scrollButtons = function scrollButtons(a) {
    if (a) {
      var apos = a.getBoundingClientRect();
      var ppos = a.parentNode.getBoundingClientRect();
      if (apos.right > ppos.right) {
        a.parentNode.scrollLeft += apos.right - ppos.right;
      } else if (apos.left < ppos.left) {
        a.parentNode.scrollLeft -= ppos.left - apos.left;
      }
    }
  };
  var galleries = qa('.gallery');
  fe(galleries, function (gallery) {
    var ob = qs('.offer-banners-buttons', gallery.parentNode);
    var slides = qa('.galleryItem');
    var galleryItems = qs('.itemButtons');
    scrollButtons(qs('.activeButton', gallery));
    mouseScroll(gallery);
    gallery.addEventListener('mouseenter', stopDelay);
    gallery.addEventListener('touchstart', stopDelay, {
      passive: true
    });
    if (galleryItems) {
      galleryItems.addEventListener('touchstart', stopDelay, {
        passive: true
      });
    }
    var setActiveButton = function setActiveButton(ib) {
      var siblings = ib.parentNode.children;
      fe(siblings, function (s) {
        if (s.classList.contains('activeButton') && s != ib) {
          s.classList.remove('activeButton');
        }
      });
      ib.classList.add('activeButton');
    };
    if (galleryItems) {
      fe(slides, function (n, i) {
        var ib = galleryItems.children[i];
        ib.addEventListener('click', function (ev) {
          var ppos = n.parentNode.parentNode.getBoundingClientRect();
          var npos = n.getBoundingClientRect();
          n.parentNode.parentNode.scrollLeft += npos.left - ppos.left;
          ev.preventDefault();
        });
        var imgs = qa('img', n);
        if (imgs.length > 0) {
          fe(imgs, function (img) {
            if (ds(img, 'video') && getWWidth() > 767) {
              var v = document.createElement('div');
              v.classList.add('v');
              var _vs = document.createElement('span');
              v.appendChild(_vs);
              var vid = document.createElement('video');
              vid.muted = true;
              if (i == 0) {
                vid.autoplay = true;
              } else {
                vid.preload = "none";
              }
              if (ds(img, 'video-loop')) {
                vid.loop = true;
              }
              var vidsrc = document.createElement('source');
              vidsrc.src = ds(img, 'video');
              var vidcap = document.createElement('track');
              vidcap.kind = 'captions';
              vidcap.srclang = 'en';
              vidcap.src = ds(img, 'vidcap');
              vid.appendChild(vidsrc);
              vid.appendChild(vidcap);
              _vs.appendChild(vid);
              img.parentNode.insertBefore(v, img);
            }
            if (ds(img, 'label')) {
              n.setAttribute('aria-label', ds(img, 'label'));
            }
          });
        }
        if (i == 0) {
          ib.classList.add('activeButton');
          setTimeout(function () {
            if (w.bannerViewEvent) {
              w.bannerViewEvent(n);
            }
          }, 0);
        }
      });
      /*if(ob) {
          ob.appendChild(galleryItems);
      } else {
          gallery.appendChild(galleryItems);
      }*/
      var gscroll = qs('.gallery_holder', gallery);
      var endscroll = function endscroll() {
        if (w.bannerViewEvent) {
          w.bannerViewEvent(activeBanner);
        }
      };
      var activeBanner = undefined;
      gscroll.addEventListener('scroll', function () {
        var smallest,
          smallestNode = undefined;
        var gpos = gallery.getBoundingClientRect();
        fe(slides, function (c, i) {
          if (typeof smallest === 'undefined' || Math.abs(c.getBoundingClientRect().left - gpos.left) < smallest) {
            activeBanner = c;
            smallest = Math.abs(c.getBoundingClientRect().left - gpos.left);
            smallestNode = galleryItems.children[i];
          }
        });
        if (smallestNode) {
          setActiveButton(smallestNode);
        }
        clearTimeout(window.scrollEndTimer);
        window.scrollEndTimer = setTimeout(endscroll, 100);
      }, {
        passive: true
      });
    } else {
      if (w.bannerViewEvent) {
        w.bannerViewEvent(qs('a', slides[0]));
      }
    }
  });
  w.setupIncrementors('');

  /* Christmas snow
  let xmas = qs('img.xmas_logo');
  if(xmas) {
      let xmastimeout;
      xmas.addEventListener('click', (e) => {
          if(xmastimeout) {
              clearTimeout(xmastimeout);
          }
          xmastimeout = setTimeout(() => {
              location.href = '/'; 
          },500);
          e.preventDefault();
          e.stopPropagation();
          return false;
      });
      xmas.addEventListener('dblclick', (e) => {
          if(xmastimeout) {
              clearTimeout(xmastimeout);
          }
          let snow = qs('#snow');
          if(snow) {
              document.body.removeChild(snow);
          } else {
              loadJS('behaviour/snow-bundle.js');
              e.preventDefault();
              e.stopPropagation();
              return false;
          }
      })
  }*/

  // Triggering custom event for when basic script page setup complete
  setTimeout(function () {
    var srevent = document.createEvent("Event");
    srevent.initEvent("scriptReady", true, true);
    srevent.eventName = "scriptReady";
    document.dispatchEvent(srevent);
  }, 0);
};
var previousHeights = 0;
var stkyobshandler = function stkyobshandler(entries, observer) {
  var bodystyles = document.body.currentStyle || window.getComputedStyle(document.body);
  var bodpadtop = Number(bodystyles.paddingTop.replace('px', '')) || 0;
  if (bodpadtop) {
    previousHeights += bodpadtop;
  }
  fe(entries, function (entry, index) {
    var cHeight = entry.target.children[0].offsetHeight;
    if (entry.boundingClientRect.y <= previousHeights) {
      if (!entry.target.classList.contains("stuk")) {
        previousHeights += cHeight;
      }
      entry.target.classList.add("stuk");
    } else {
      if (entry.target.classList.contains("stuk")) {
        previousHeights -= cHeight;
      }
      entry.target.classList.remove("stuk");
      entry.target.style.zIndex = '';
      entry.target.style.top = '';
      if (entry.boundingClientRect.y > -cHeight) {
        entry.target.children[0].style.transform = '';
        Object.assign(entry.target.children[0].style, {
          transform: '',
          transition: ''
        });
      }
    }
    w.checksct();
  });
};

// Intersection observer handlers
var bottomstkyobsHandler = function bottomstkyobsHandler(entries, observer) {
  fe(entries, function (entry, index) {
    var s = qs('.stky', entry.target);
    if (entry.boundingClientRect.y < -entry.target.offsetHeight + 1) {
      if (s.offsetHeight == 0) {
        s.classList.remove("stuk");
        s.offsetHeight;
      }
      s.parentNode.style.minHeight = s.offsetHeight + 'px';
      s.classList.add("stuk");
    } else {
      s.classList.remove("stuk");
      s.style.zIndex = '';
      s.children[0].style.transform = '';
      Object.assign(s.children[0].style, {
        transform: '',
        transition: ''
      });
      s.parentNode.style.minHeight = '';
    }
    w.checksct();
  });
};

//Top level nav links e.g Categories, Brands, Need Help
var closenl = function closenl(e) {
  var active = qs('.navlink.active');
  active.click();
  e.target.classList.remove('active');
};
var nlclick = function nlclick(e) {
  var a = e.target;
  if (a.nodeName != 'A') {
    a = a.closest('a');
  }
  var ahref = a.getAttribute('href');
  var targetid = ahref.substring(ahref.indexOf('#'), ahref.length);
  var par = a.closest('.transnav,body');
  var tgt = qs(targetid);
  fe(qa('.navlink.active'), function (a) {
    a.classList.remove('active');
  });
  a.classList.remove('active');
  var tgts = tgt.currentStyle || window.getComputedStyle(tgt);
  var backing = qs('.nebacking');
  if (tgts.display == 'none') {
    a.classList.add('active');
    backing.removeEventListener('click', closenl);
    backing.addEventListener('click', closenl);
    backing.classList.add('active');
    if (a.parentNode.classList.contains('shopoptions')) {
      var oldtgts = ap.filter.call(qa('.shopoptions > div, .navexpand > div'), function (b) {
        return b.offsetHeight > 0 && !b.classList.contains('navlink') && !b.classList.contains('btn');
      });
      if (oldtgts.length > 0) {
        fe(oldtgts, function (oldtgt) {
          slideUp(oldtgt);
        });
        slideDown(tgt);
      } else {
        slideDown(tgt);
      }
    } else {
      slideDown(tgt);
    }
    var childDload = qs('.dLoad', tgt);
    if (childDload) {
      w.dynamicLoad(childDload);
    }
  } else {
    a.classList.remove('active');
    slideUp(tgt);
    backing.removeEventListener('click', closenl);
    backing.classList.remove('active');
  }
  e.preventDefault();
};
var setupnls = function setupnls(a) {
  var ahref = a.getAttribute('href');
  var targetid = ahref.substring(ahref.indexOf('#'), ahref.length);
  var par = a.closest('.transnav,body');
  var tgt = qs(targetid);
  if (tgt) {
    tgt.classList.remove('jshidden');
    if (!a.classList.contains('active')) {
      tgt.style.display = 'none';
    }
    if (par.classList.contains('transnav')) {
      a.insertAdjacentElement('afterend', tgt);
    } else {
      qs('.navexpand').appendChild(tgt);
    }
    a.removeEventListener('click', nlclick);
    a.addEventListener('click', nlclick);
  }
};

// Array of  functions to call when cabox is opened
if (_typeof(w.caboxPoppedFunctions) != 'object') {
  w.caboxPoppedFunctions = [];
}
var caboxpc = function caboxpc() {
  var pcn = qs('#postcode', qs('#cabox'));
  pcn.value = pcn.value.replace(/[^a-zA-Z0-9 ]*/gi, '');
};
w.caboxPoppedFunctions.push(function () {
  var cabn = qs('#cabox');
  var pcf = qs('.postcodeform', cabn);
  if (pcf) {
    pcf.removeEventListener('submit', caboxpc);
    pcf.addEventListener('submit', caboxpc);
  }
  var pgio = qs('.pgitem .offer', cabn);
  if (pgio) {
    pgio.removeEventListener('submit', vatSwitcher);
    pgio.addEventListener('submit', vatSwitcher);
  }
  var iframeReplace = qs('.iframereplace', cabn);
  if (iframeReplace) {
    iframeReplace.addEventListener('click', function (e) {
      e.preventDefault();
      var iframeNode = document.createElement('iframe');
      iframeNode.setAttribute('allow', "autoplay");
      iframeNode.setAttribute('src', e.target.getAttribute('href'));
      var frameHolder = document.createElement('div');
      frameHolder.id = 'caframeholder';
      frameHolder.appendChild(iframeNode);
      iframeReplace.parentNode.insertBefore(frameHolder, iframeReplace);
      iframeReplace.parentNode.removeChild(iframeReplace);
    });
  }
  var video = qs('video', cabn);
  if (video) {
    video.removeAttribute('preload');
  }
});
w.popDivContent = function (t, maxwidth) {
  if (t.indexOf('#') == 0 && qs(t)) {
    var c = qs(t).cloneNode(true);
    c.classList.remove('jspopup');
    var o = {
      content: c,
      onComplete: function onComplete() {
        for (var i = 0; i < w.caboxPoppedFunctions.length; i++) {
          w.caboxPoppedFunctions[i]();
        }
      }
    };
    if (maxwidth) {
      o.maxwidth = maxwidth;
    }
    cabox.init(null, o);
  }
};

//Utility function to prevent calls being called to often
w.throttle = function (fn, threshhold, scope) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || _this;
    var now = +new Date();
    if (last && now < last + threshhold) {
      // hold on to it 
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

//Short hand to trigger vat switches, cookie system
var vatSwitch = function vatSwitch(i, o) {
  var b = document.body;
  if (b.classList.contains(o + 'vat') && !b.classList.contains(i + 'vatin')) {
    b.className = b.className.replace(' ' + o + 'vatin', '') + ' ' + i + 'vatin';
    setTimeout(function () {
      if (b.className.indexOf(i + 'vatin') > -1) {
        if (dataLayer) {
          dataLayer.push({
            event: 'vat_switch',
            value: i
          });
        }
        b.className = "".concat(b.className.replace(new RegExp(' ?(ex|in)cvat(in)?', 'g'), ''), " ").concat(o, "vatin ").concat(i, "vat");
        setTimeout(function () {
          b.classList.remove(o + 'vatin');
          if (typeof filtersRender == 'function') {
            filtersRender();
          }
        }, 5);
      }
    }, 300);
    document.cookie = "cookievat=".concat(i, "vat;path=/;samesite=lax");
  }
};
var activateIncVat = function activateIncVat() {
  vatSwitch('inc', 'exc');
};
var activateExcVat = function activateExcVat() {
  vatSwitch('exc', 'inc');
};
var cookievat = document.cookie.match(/cookievat=([^;]+)/);
w.vatSwitcher = function () {
  var b = document.body;
  if (b.className.indexOf('incvat') > -1) {
    activateExcVat();
  } else {
    activateIncVat();
  }
};

// Pop out information on hover
w.ipopSetup = function (sel) {
  var cont = qs(sel);
  var ipops = qa('.ipop', cont);
  if (ipops.length > 0) {
    var ipop = qs('.ipopout', document.body);
    if (!ipop) {
      ipop = document.createElement('div');
      ipop.className = 'ipopout';
      ipop.innerHTML = '<div id="ipopcontent"></div><span class="icon poparrow"></span>';
      document.body.appendChild(ipop);
    }
    var ipopcontent = ipop.children[0];
    fe(ipops, function (ip) {
      ds(ip, 'title', ip.title);
      ip.title = '';
      ip.addEventListener('mouseenter', function () {
        var pos = ip.getBoundingClientRect();
        st = window.pageYOffset;
        if (ip.classList.contains('vert')) {
          if (!ipop.classList.contains('vert')) {
            ipop.classList.add('vert');
          }
          ipopcontent.innerHTML = ds(ip, 'title');
          Object.assign(ipop.style, {
            top: "".concat(pos.top + st + ip.offsetHeight + 13, "px"),
            left: "".concat(pos.left + ip.offsetWidth / 2, "px")
          });
        } else {
          ipop.classList.remove('vert');
          ipopcontent.innerHTML = ds(ip, 'title');
          Object.assign(ipop.style, {
            top: "".concat(pos.top + st + ip.offsetHeight / 2, "px"),
            left: "".concat(pos.left + ip.offsetWidth + 13, "px")
          });
        }
        fadeIn(ipop);
      });
      ip.addEventListener('mouseout', function () {
        fadeOut(ipop);
      });
    });
  }
};

// Analytics and GA4 information
w.gatrackclick = function (a, cat, lab, val, e) {
  if (typeof gapvc == 'function') {
    gapvc();
  }
  if (dataLayer) {
    dataLayer.push({
      'event': 'click',
      'event_category': cat,
      'event_label': lab,
      'value': val,
      'eventCallback': function eventCallback() {
        if (a.href) {
          location.href = a.href;
        } else if (a.type == 'submit') {
          var frm = a.closest('form');
          frm.submit();
        }
      }
    });
  }
  if ((typeof google_tag_manager === "undefined" ? "undefined" : _typeof(google_tag_manager)) === 'object' && e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
  return true;
};
var prodadded = false;
w.ga4a2b = function () {
  if (window.proddata) {
    var proddata = window.proddata;
    var q = qs('#quantity');
    proddata.quantity = q.value;
    var mpn = qs('span[itemprop="mpn"]');
    if (mpn) {
      proddata.varient = mpn.textContent;
    }
    proddata.price = ds(q, 'price');
    dataLayer.push({
      ecommerce: null
    });
    var item = {
      'item_name': proddata.name,
      'item_id': proddata.id,
      'price': proddata.price,
      'item_brand': proddata.brand,
      'item_category': proddata.category,
      'quantity': proddata.quantity
    };
    if (lastList != null && typeof lastList != 'undefined') {
      item.item_list_name = lastList;
    }
    if (lastPromo != null && typeof lastPromo != 'undefined') {
      item.promotion_name = lastPromo;
    }
    dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'items': [item]
      }
    });
    var sa = JSON.parse(localStorage.getItem("savedattr") || '{}');
    if (item.item_list_name || item.promotion_name) {
      var o = {};
      if (item.item_list_name) {
        o.list = item.item_list_name;
      }
      if (item.promotion_name) {
        o.promo = item.promotion_name;
      }
      sa[proddata.id] = o;
      localStorage.setItem("savedattr", JSON.stringify(sa));
    }
  }
};
w.gaAddToBasket = function (f) {
  if (!prodadded && window.proddata) {
    var proddata = window.proddata;
    var q = qs('#quantity');
    proddata.quantity = q.value;
    var mpn = qs('span[itemprop="mpn"]');
    if (mpn) {
      proddata.varient = mpn.textContent;
    }
    proddata.price = ds(q, 'price');
    if (typeof gapvc == 'function') {
      gapvc();
    }
    dataLayer.push({
      ecommerce: null
    });
    var item = {
      'item_name': proddata.name,
      'item_id': proddata.id,
      'price': proddata.price,
      'item_brand': proddata.brand,
      'item_category': proddata.category,
      'quantity': proddata.quantity
    };
    if (lastList != null && typeof lastList != 'undefined') {
      item.item_list_name = lastList;
    }
    if (lastPromo != null && typeof lastPromo != 'undefined') {
      item.promotion_name = lastPromo;
    }
    dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'items': [item]
      }
    });
    return true;
  }
};

// Get total width of children (including margin right)
var getChildenPerWidth = function getChildenPerWidth(a) {
  var total = 0;
  fe(a, function (c) {
    if (!c.classList.contains('paddingadd')) {
      var style = c.currentStyle || window.getComputedStyle(c);
      var hspace = Number(style.marginRight.replace('px', ''));
      if (c.parentNode.parentNode.offsetWidth >= total + c.offsetWidth) {
        total += c.offsetWidth + hspace;
      }
    }
  });
  return total;
};

// Utility class for currency display
w.currencyPad = function (num, nocommas) {
  var str = String(num);
  if (str.indexOf('.') < 0) {
    str = str + ".00";
  } else {
    str = String(Math.round(num * 100) / 100);
    if (str.indexOf('.') < 0) {
      str = str + ".00";
    } else if (str.indexOf('.') == str.length - 2) {
      str = str + "0";
    }
  }
  if (nocommas) {
    return str;
  } else {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};
window.userhash = true;
window.scripthash = false;

//Crossbrowser trigger event function
w.triggerEvent = function (element, etype) {
  var evt = document.createEvent("Event");
  evt.initEvent(etype, true, true);
  element.dispatchEvent(evt);
};
var notfirstPage = true;
if (localStorage) {
  notfirstPage = localStorage.getItem('notfirstPage');
  if (notfirstPage) {
    document.body.classList.add('notfirst');
  }
}

// Trigger on load (with lazy loading images this happens quickly) for thurd party scripts
var pageLoadComplete = function pageLoadComplete() {
  var loadFunction = function loadFunction() {
    if (localStorage) {
      if (!notfirstPage) {
        try {
          localStorage.setItem('notfirstPage', true);
        } catch (e) {
          notfirstPage = true;
        }
      }
    }
    if (sct) {
      sct.classList.add('loaded');
    }
    triggerEvent(window, 'resize');
    if (notfirstPage) {
      activeGTM();
      setTimeout(function () {
        optionalFunc();
        funcCook();
      }, 3000);
    } else {
      setTimeout(function () {
        optionalFunc();
        funcCook();
        activeGTM();
      }, 3500);
    }
  };
  if (idl) idl(function () {
    window.setTimeout(loadFunction, 10);
  });else loadFunction();
};
var optactive = 0;
var optionalFunc = function optionalFunc() {
  if (cprefs[2] == '1' && !optactive) {
    optactive = 1;
    /*window.$crisp=[];window.CRISP_WEBSITE_ID="1acb76fe-a3cb-4aa5-9d0e-775f9777d6a1";
    $crisp.push(["on", "session:loaded", () => {qs('.cc-1oun').setAttribute('aria-label','Chat with our sales team')} ]);
    loadJS('https://client.crisp.chat/l.js');*/
    if (!document.referrer.includes('catering-appliance') && !document.referrer.includes('localhost')) {
      document.documentElement.classList.add('first');
    }
    if (typeof gcrmi != 'undefined') {
      loadJS('https://apis.google.com/js/platform.js', function () {
        var ratingBadgeContainer = document.createElement("div");
        document.body.appendChild(ratingBadgeContainer);
        window.gapi.load('ratingbadge', function () {
          window.gapi.ratingbadge.render(ratingBadgeContainer, {
            "merchant_id": gcrmi,
            "position": "TOP_LEFT"
          });
          qs('#___ratingbadge_0').children[0].title = 'Google Shopping Customer Reviews';
        });
      });
    }
  }
};
var funcactive = 0;
var funcCook = function funcCook() {
  if (!funcactive && cprefs[1] == '1') {
    var fb = document.createElement('img');
    fb.style.display = 'block';
    fb.style.overflow = 'hidden';
    fb.style.height = '0px';
    fb.src = "https://www.facebook.com/tr?id=324047364907932&ev=PageView&noscript=1";
    fb.alt = "";
    document.body.appendChild(fb);
  }
  if (location.href.indexOf('checkout') == -1 && location.href.indexOf('?') == -1) {
    loadJS(asc + '/shop/vendor/qrcode.min.js', function () {
      var footqr = document.createElement('div');
      footqr.classList.add('printonly');
      var qr = qrcode(0, 'L');
      qr.addData(location.href);
      qr.size;
      qr.make();
      footqr.innerHTML = qr.createSvgTag({
        scalable: true
      });
      qs('svg', footqr).style.width = '200px';
      qs('svg', footqr).style.height = '200px';
      qs('.footer .cols').appendChild(footqr);
    });
  }
};

// Horizontal scrollers with buttons
w.setupHScrollers = function (hshs) {
  var tstartX, tstartY, tX, tY;
  var ascrolling = false;
  fe(hshs, function (hsh) {
    var hs = qs('.hscroller', hsh);
    var hsw = qs('.hscrollerwidth', hs);
    var getHSWidth = function getHSWidth() {
      var width = hs.offsetWidth;
      var hsstyle = hs.currentStyle || window.getComputedStyle(hs);
      var hswstyle = hsw.currentStyle || window.getComputedStyle(hsw);
      if (hsstyle.paddingLeft) {
        width -= Number(hsstyle.paddingLeft.replace('px', ''));
      }
      if (hsstyle.paddingRight) {
        width -= Number(hsstyle.paddingRight.replace('px', ''));
      }
      if (hswstyle.gap) {
        width += Number(hswstyle.gap.replace('px', ''));
      }
      return width;
    };
    var lb = qs('.left_arrow', hsh);
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'left_arrow disabled';
      lb.innerHTML = '<div><span class="icon arrowleft"></span></div>';
      hsh.insertBefore(lb, hs);
    }
    lb.addEventListener('click', function () {
      if (!lb.classList.contains('disabled') && !ascrolling) {
        if (hsw.children.length > 0) {
          ascrolling = true;
          var hscollerwidth = getHSWidth();
          var target = hs.scrollLeft - hscollerwidth;
          if (target < 0) {
            target = 0;
          }
          goToScrollLeft(hs, target);
          setTimeout(function () {
            ascrolling = false;
          }, 500);
        }
      }
    });
    var rb = qs('.right_arrow', hsh);
    if (!rb) {
      rb = document.createElement('div');
      rb.className = 'right_arrow';
      rb.innerHTML = '<div><span class="icon arrowright"></span></div>';
      hsh.insertBefore(rb, hs);
    }
    rb.addEventListener('click', function () {
      if (!rb.classList.contains('disabled') && !ascrolling) {
        if (hsw.children.length > 0) {
          ascrolling = true;
          var hscollerwidth = getHSWidth();
          var target = hs.scrollLeft + hscollerwidth;
          if (target >= hs.scrollWidth - hs.offsetWidth) {
            target = hs.scrollWidth - hs.offsetWidth - 1;
          }
          goToScrollLeft(hs, target);
          setTimeout(function () {
            ascrolling = false;
          }, 500);
        }
      }
    });
    var scrollTimeout;
    var scrolledhs = function scrolledhs() {
      var sl = hs.scrollLeft;
      var lbd = lb.classList.contains('disabled');
      var rbd = rb.classList.contains('disabled');
      if (sl == 0 && !lbd) {
        lb.classList.add('disabled');
      } else if (sl != 0 && lbd) {
        lb.classList.remove('disabled');
      }
      if (sl >= hs.scrollWidth - hs.offsetWidth - 10 && !rbd) {
        rb.classList.add('disabled');
      } else if (sl < hs.scrollWidth - hs.offsetWidth - 10 && rbd) {
        rb.classList.remove('disabled');
      }
    };
    hs.addEventListener('scroll', throttle(scrolledhs));
    window.addEventListener('resize', throttle(scrolledhs, 250));
    var observer = new IntersectionObserver(function (entries) {
      scrolledhs();
      observer.disconnect();
    });
    observer.observe(hs);
  });
};

// Search autocomplete
var initAutoSearch = function initAutoSearch(element) {
  var search = element;
  var scontroller;
  search.setAttribute("autocomplete", "off");
  var positionAutoSearch = function positionAutoSearch() {
    if (output.style.display != 'none') {
      var outputPosition = search.getBoundingClientRect();
      var parentPosition = search.closest('.stky > div').getBoundingClientRect();
      output.style.left = outputPosition.left + "px";
      output.style.top = outputPosition.bottom - parentPosition.top - search.offsetHeight / 2 + "px";
      output.style.width = search.offsetWidth - 2 + "px";
      searchoutput.style.maxHeight = window.innerHeight - outputPosition.bottom + st - 20 + "px";
    }
  };
  var hide = function hide() {
    search.classList.remove('active');
    output.style.display = 'none';
    search.classList.remove('completing');
  };
  var moveKeySelect = function moveKeySelect(direction, output) {
    var activeClassName = 'keyselect';
    var items = Array.from(qa('.item', output));
    if (items.length === 0) {
      return;
    }
    var activeList = items.map(function (element, index) {
      return element.classList.contains(activeClassName) ? index : null;
    }).filter(function (index) {
      return null !== index;
    });
    activeList.forEach(function (index) {
      items[index].classList.remove(activeClassName);
    });
    var active = items[Math.min(Math.max(0, (activeList.length > 0 ? activeList[0] : -1) + direction), items.length - 1)];
    active.classList.add(activeClassName);
    active.scrollIntoView({
      block: 'end'
    });
  };
  var output = document.createElement("div");
  output.className = "search-autocomplete default";
  output.style.display = "none";
  output.style.position = "absolute";
  var searchoutput = document.createElement("div");
  searchoutput.className = "search-autocomplete-holder";
  output.appendChild(searchoutput);
  search.parentNode.parentNode.parentNode.appendChild(output);
  output.addEventListener('focusout', function (event) {
    if (scontroller) {
      scontroller.abort('Operation cancelled by the user');
    }
    if (!event.target || !output.contains(event.target)) {
      hide();
    }
  });
  var lastSearchQuery;
  var timeout = null;
  search.addEventListener('keydown', function (e) {
    var charCode = typeof e.which == 'number' ? e.which : e.keyCode;
    if (qa('.item', output).length > 0) {
      switch (charCode) {
        case 38:
          e.preventDefault();
          moveKeySelect(-1, output);
          return false;
        case 40:
          e.preventDefault();
          moveKeySelect(1, output);
          return false;
        case 13:
          var ks = qs('.item.keyselect', output);
          if (ks) {
            e.preventDefault();
            var a = qs('a', ks);
            if (a) {
              location.href = a.getAttribute('href');
            }
            return false;
          }
          break;
        case 27:
          e.preventDefault();
          lastSearchQuery = null;
          output.innerHTML = '';
          hide();
          return false;
        case 13:
          gtmPush({
            'event': 'siteSearch',
            'searchTerm': search.value
          });
      }
    }
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(lookup, 400);
  });
  search.addEventListener('focus', function () {
    search.classList.add('active');
    if (lastSearchQuery) {
      output.style.display = 'block';
      search.classList.add('completing');
      positionAutoSearch();
    } else if (search.value.length > 0) {
      lookup();
    }
  });
  window.document.addEventListener('click', function (e) {
    if (search.classList.contains('active') && !output.contains(e.target) && e.target != search) {
      hide();
    }
  });
  window.addEventListener('resize', throttle(positionAutoSearch, 250));
  var lastViewed = "default";
  var lookup = function lookup() {
    if (document.activeElement == search) {
      timeout = null;
      output.style.display = 'block';
      search.classList.add('completing');
      positionAutoSearch();
      if (scontroller) {
        scontroller.abort('Operation cancelled by the user');
      }
      scontroller = new AbortController();
      var searchQuery = search.value;
      if (searchQuery.length === 0) {
        hide();
        return;
      }
      if (searchQuery === lastSearchQuery) {
        return;
      }
      fetch("/search?q=".concat(encodeURIComponent(searchQuery), "&chr=0&auto=1"), {
        signal: scontroller.signal
      }).then(function (res) {
        return res.text();
      }).then(function (actext) {
        lastSearchQuery = searchQuery;
        if (actext.indexOf('#' + lastViewed) == -1) {
          output.classList.remove(lastViewed);
          output.classList.add('default');
        }
        searchoutput.innerHTML = actext;
        fe(qa('.tab', output), function (a) {
          a.addEventListener('click', function (e) {
            var tgt = a.href.substring(a.href.indexOf('#') + 1, a.href.length);
            output.classList.remove(lastViewed);
            output.classList.add(tgt);
            lastViewed = tgt;
            e.preventDefault();
          });
        });
        fe(qa('.padding a', output), function (a) {
          a.addEventListener('click', function (e) {
            localStorage ? localStorage.setItem('lastList', 'Search AutoComplete') : null;
            gtmPush({
              'event': 'siteSearch',
              'searchTerm': search.value
            });
          });
          a.addEventListener('keydown', function (e) {
            var charCode = typeof e.which == 'number' ? e.which : e.keyCode;
            if (charCode == 27) {
              search.focus();
            }
          });
        });
      })["catch"](function (e) {
        console.log(e);
      });
    }
  };
};

// Utility to get window width of page without triggering reflow unless needed
w.getWWidth = function (force) {
  if (lastwwidth == 0 || force) {
    var _w2 = window,
      a = 'inner';
    if (!('innerWidth' in window)) {
      a = 'client';
      _w2 = document.documentElement || document.body;
    }
    return _w2[a + 'Width'];
  } else {
    return lastwwidth;
  }
};
var lastwwidth = 0;
var viewMode = '';

// Mobile only expander action
var mobileHeadClick = function mobileHeadClick(e) {
  var h = e.target;
  if (!h.classList.contains('mobile_expand_head')) {
    h = h.parentNode;
  }
  var vissib = qs('.mobile_expand_body', h.parentNode);
  if (vissib.offsetHeight > 0) {
    h.classList.remove('active');
    slideUp(vissib);
  } else {
    h.classList.add('active');
    slideDown(vissib);
  }
};

// Expanding filter display
w.filterHeadClick = function (e) {
  var f = e.target;
  if (!f.classList.contains('filter_head')) {
    f = f.closest('.filter_head');
  }
  if (f.classList.contains('active')) {
    f.classList.remove('active');
    slideUp(f.nextElementSibling);
  } else {
    f.classList.add('active');
    slideDown(f.nextElementSibling);
    setTimeout(function () {
      var b = f.nextElementSibling;
      var rect = b.getBoundingClientRect();
      if (rect.bottom > 0) {
        b.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }, 300);
  }
};

//Master Page Resize Function
window.compareset = false;
var filterNode;
var initMobile = function initMobile() {
  var wwidth = getWWidth(true);
  var m = qs('#nav');
  var tnav = qs('#transnav0');
  var ne = qs('#navexpander');
  if (wwidth != lastwwidth) {
    if (window.matchMedia(msm).matches) {
      if (viewMode != 'mobile' && m) {
        if (!qs('.menu-toggle', m)) {
          qs('.stky').after(qs('#nav'));
          ds(m, 'navid', 0);
          if (!tnav) {
            tnav = document.createElement('div');
            tnav.id = 'transnav0';
            tnav.className = 'transnav';
            document.body.insertBefore(tnav, document.body.firstChild);
            tnav.addEventListener('click', function (e) {
              if (e.target.nodeName !== 'A' && !e.target.closest('.shopoptions')) {
                var clickedNav = qs('.menu-toggle.selected');
                if (clickedNav) {
                  clickedNav.click();
                }
              }
            });
          }
          tnav.insertBefore(qs('.shopoptions'), tnav.firstChild);
          var nls = qa('.navlink', tnav);
          if (nls.length > 0) {
            fe(nls, setupnls);
          }
          var first = ('ul:first-child', tnav);
          fe(first.children, function (c) {
            if (!c.classList.contains('main')) {
              c.classList.add('main');
            }
          });
          if (!m.classList.contains('jsactive')) {
            m.classList.add('jsactive');
          }
          var obc = qs('.basketcorner');
          var mt = document.createElement('div');
          mt.className = 'menu-toggle';
          mt.innerHTML = "<span class=\"mobileicons\">\n<a href=\"tel:01539760650\"><span class=\"icon-phone icon\"><i class=\"alttext\">Phone us</i></span></a> \n<a href=\"/account/\"><span class=\"icon-account icon\"><i class=\"alttext\">Your Account</i></span></a> \n<a href=\"/shop/basket/\" id=\"mobilemb\"><span class=\"icon-basket icon\"><i class=\"alttext\">Your Basket</i></span><span class=\"basketcorner\">".concat(obc ? obc.textContent : '0', "</span></a>\n</span>\n<span class=\"icon\">\n<span class=\"line\"></span>\n</span>\n<span class=\"tog-menu\"></span>");
          m.insertBefore(mt, m.firstChild);
          fe(qs('.mobileicons'), function (mi) {
            mi.addEventListener('click', function (e) {
              e.stopPropagation();
            });
          });
        }
        if (!qs('.menu-toggle.selected', m)) {
          fe(m.children, function (c) {
            if (!c.classList.contains('menu-toggle')) {
              c.style.display = 'none';
            } else {
              c.removeEventListener('click', mobileSlideMenuDisplay);
              c.addEventListener('click', mobileSlideMenuDisplay);
            }
          });
          fe(qa('.menu-toggle a', m), function (n) {
            n.addEventListener('click', function (e) {
              e.stopPropagation();
            });
          });
        }
        qs('.tog-menu', m).textContent = '';
        fe(qa('.mobile_expand_head'), function (a) {
          a.removeEventListener('click', mobileHeadClick);
          a.addEventListener('click', mobileHeadClick);
          if (!a.classList.contains('active')) {
            fe(a.parentNode.children, function (b) {
              if (b.classList.contains('mobile_expand_body')) {
                b.style.display = 'none';
              }
            });
          }
        });
        var ca = qa('.categorynav .ul + .ul');
        var tgts = qa('.categorynav .active a');
        fe(ca, function (ul, i) {
          tgts[i].parentNode.appendChild(ul);
        });
        var stky = qa('.stky');
        window.stkyobs = new IntersectionObserver(stkyobshandler, {
          threshold: [0, 1],
          rootMargin: "48px 0px 0px 0px"
        });
        window.bottomstkyobs = new IntersectionObserver(bottomstkyobsHandler, {
          threshold: [0, 1],
          rootMargin: "48px 0px 0px 0px"
        });
        fe(stky, function (s) {
          if (s.classList.contains('fixbottom')) {
            bottomstkyobs.observe(s.parentNode);
          } else {
            stkyobs.observe(s);
          }
        });
        viewMode = 'mobile';
      }
    } else {
      if (viewMode != 'desktop' && m) {
        fe(qa('.menu-toggle'), function (a) {
          a.parentNode.removeChild(a);
        });
        qs('.siteheader').after(qs('#nav'));
        qs('.logo').after(qs('.shopoptions'));
        //qs('.topbar__tagline').insertAdjacentElement('afterend',);
        var es = qs('#expandsubnav');
        fe(qa('.dl', ne), function (a) {
          es.appendChild(qs('#navexpanderlist' + ds(a, 'list')));
        });
        //qs('.topbar__tagline').insertAdjacentElement('afterend',);
        //Top level nav links e.g Categories, Brands, Need Help
        var _nls = qa('.navlink');
        if (_nls.length > 0) {
          fe(_nls, setupnls);
        }
        fe(m.children, function (a) {
          if (!a.classList.contains('.menu-toggle')) {
            a.style.display = '';
            fe(a.children, function (b) {
              if (b.classList.contains('icon')) {
                a.removeChild(b);
              }
            });
          }
        });
        fe(qa('.transnav'), function (a) {
          a.style.display = '';
        });
        qs('.navholder').style.height = '';
        fe(qa('.mobile_expand_head'), function (a) {
          a.removeEventListener('click', mobileHeadClick);
        });
        fe(qa('.mobile_expand_body'), function (a) {
          a.style.display = '';
        });
        var _ca = qa('.categorynav .ul .ul');
        var tgt = qs('.categorynav .dLoad');
        fe(_ca, function (ul) {
          tgt.appendChild(ul);
        });
        var _stky = qa('.stky');
        w.stkyobs = new IntersectionObserver(stkyobshandler, {
          threshold: [0, 1],
          rootMargin: "0px 0px 0px 0px"
        });
        w.bottomstkyobs = new IntersectionObserver(bottomstkyobsHandler, {
          threshold: [0, 1],
          rootMargin: "0px 0px 0px 0px"
        });
        fe(_stky, function (s) {
          if (s.classList.contains('fixbottom')) {
            if (w.bottomstkyobs) {
              w.bottomstkyobs.unobserve(s.parentNode);
            }
            bottomstkyobs.observe(s.parentNode);
          } else {
            if (w.stkyobs) {
              w.stkyobs.unobserve(s.parentNode);
            }
            stkyobs.observe(s);
          }
        });
        viewMode = 'desktop';
      }
    }
    var resizeChecks = function resizeChecks() {
      if (typeof filterNode == 'undefined') {
        filterNode = qs('.filterpanel');
      }
      if (filterNode && typeof filterNode !== 'undefined') {
        var fh = qa('.filter_head:not(.exp)', filterNode);
        if (fh && fh.length) {
          fe(fh, function (h) {
            h.addEventListener('click', filterHeadClick);
            h.classList.add('exp');
            if (!h.classList.contains('active')) {
              h.nextElementSibling.style.display = 'none';
            }
          });
        }
      }
      if (typeof mobileManexpand == 'function') {
        mobileManexpand();
      }
      if (tabsApplied) {
        tabResize();
      }

      // TODO check if this is still used
      /*const ytf = qa('.youtubeframe');
      if(ytf.length > 0) {
          fe(ytf,y => {
              y.style.height = (y.offsetWidth * 0.558) + "px";
          });
      }
      equalRowHeight(qa('.equals'));*/

      //cabox.init(qa('.fancyexclusive'));

      if (!window.compareset) {
        fe(qa('.comparebtn'), function (n) {
          n.removeEventListener('click', window.compareClick);
          n.addEventListener('click', window.compareClick);
        });
        window.compareset = true;
      }
      positionBasketpop();
      w.checksct();
    };
    if (raf) raf(function () {
      window.setTimeout(resizeChecks, 10);
    });else window.setTimeout(resizeChecks, 10);
  }
  lastwwidth = wwidth;
};

//Position sticky elements so they stack
var sct = qs('#sctop');
var scttime;
w.checksct = function () {
  if (sct) {
    if (scttime) {
      clearTimeout(scttime);
    }
    var y = window.scrollY;
    scttime = setTimeout(function () {
      var stuk = qa('.stuk');
      var sctmt = window.matchMedia('(max-width:947px)').matches ? 48 : 0;
      for (var i = 0; i < stuk.length; i++) {
        var s = stuk[i];
        if (!s.classList.contains('fixbottom')) {
          s.style.top = '';
        }
        if (s && s.classList.contains('fixbottom') ? s.getBoundingClientRect().bottom < 0 : s.getBoundingClientRect().top <= sctmt) {
          if (s.classList.contains('fixbottom')) {
            Object.assign(s.children[0].style, {
              transform: "translate(0,".concat(sctmt, "px)"),
              transition: 'transform 0.2s linear'
            });
          } else {
            Object.assign(s.style, {
              top: "".concat(sctmt, "px")
            });
            if (!s.parentNode.classList.contains('category_right')) {
              sctmt += s.children[0].offsetHeight;
            }
          }
          s.style.zIndex = 99 - i;
        }
      }
      ;
      var nstk = qa('.stky:not(.stuk):not(.fixbottom)');
      fe(nstk, function (n) {
        n.style.top = "".concat(sctmt, "px");
      });
      sct.style.transform = "translateY(".concat(sctmt - 5, "px)");
    }, 100);
  }
};

// Add to Compare features
window.compareClick = function (e) {
  var a = e.target;
  if (!a.classList.contains('.comparebtn')) {
    a = a.closest('.comparebtn');
  }
  var par = a.closest('form');
  var prodid = qs('input[name="product_id"]', par).value;
  var title = qs('h2', a.closest('.title'));
  if (typeof gtag == 'function') {
    gtag('event', 'add_to_compare', {
      'product_id': prodid,
      'product_name': title.textContent
    });
  }
  var urlEncodedDataPairs = [];
  var sendData = {
    product_id: prodid,
    json: true
  };
  for (var name in sendData) {
    urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(sendData[name]));
  }
  fetch("/products/compare/add.php", {
    method: 'POST',
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    body: urlEncodedDataPairs.join('&')
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    a.removeEventListener('click', compareClick);
    a.addEventListener('click', function (e) {
      location.href = "/products/compare/";
      e.preventDefault();
      return false;
    });
    if (a.classList.contains('compare_product')) {
      var ic = qs('.icon', a);
      ic.className = ic.className.replace('compare_icon', '') + ' add_confirm';
      fe(qa('.compare_added,.compare_circle,.compare_product'), function (c) {
        c.classList.add('added_active');
      });
    } else {
      a.innerHTML = 'View Compare <span class="icon-compare icon"></span>';
    }
  });
  e.preventDefault();
  e.stopPropagation();
  return false;
};

//Reposition basket popup on resize
w.positionBasketpop = function () {
  if (typeof clickedButton == 'string') {
    st = window.pageYOffset;
    var targetButton = qs('#' + clickedButton);
    if (targetButton) {
      var targetButtonpos = targetButton.getBoundingClientRect();
      var wwidth = lastwwidth;
      var bp = qs('.basketpop');
      if (wwidth > 1015) {
        Object.assign(bp.style, {
          top: "".concat(targetButtonpos.top + st, "px"),
          left: "".concat(targetButtonpos.left - (bp.offsetWidth + 30), "px"),
          right: '',
          width: ""
        });
      } else {
        Object.assign(bp.style, {
          right: "".concat(Math.min(targetButtonpos.right - targetButton.offsetWidth / 2, 0), "px"),
          left: '',
          top: "".concat(targetButtonpos.top + targetButton.offsetHeight + 17 + st, "px"),
          width: targetButton.offsetWidth * 2 + 'px'
        });
      }
    }
  }
};

// Display/Hide mobile navigation
var anbtn;
var mobileSlideMenuDisplay = function mobileSlideMenuDisplay(e) {
  anbtn = e.target;
  var navid = ds(anbtn.parentNode, 'navid');
  ;
  while (!navid) {
    anbtn = anbtn.parentNode;
    navid = ds(anbtn.parentNode, 'navid');
  }
  if (anbtn.classList.contains('selected')) {
    anbtn.classList.remove("selected");
    slideUp(qs('#transnav' + navid));
  } else {
    anbtn.classList.add("selected");
    slideDown(qs('#transnav' + navid));
  }
  e.preventDefault();
};

// Equal product row section heights
w.equalRowHeight = function (nodes, o) {
  var opts = o ? o : {};
  var tallest = [];
  if (nodes && nodes.length > 0) {
    fe(nodes, function (n, i) {
      n.style.height = '';
      if (opts.minHeight) {
        n.style.minHeight = opts.minHeight;
      }
    });
    window.offsetHeight;
    var data = [];
    fe(nodes, function (n, i) {
      if (opts.rowLength) {
        tallest[Math.floor(i / opts.rowLength)] = Math.max(n.offsetHeight, tallest[Math.floor(i / opts.rowLength)] || 0);
      } else {
        var rect = n.getBoundingClientRect();
        var p = rect.top + st;
        data[i] = Math.floor(p);
        tallest[Math.floor(p)] = Math.max(n.offsetHeight, tallest[Math.floor(p)] || 0);
      }
    });
    fe(nodes, function (n, i) {
      if (opts.rowLength) {
        n.style.height = tallest[Math.floor(i / opts.rowLength)] + 'px';
      } else {
        n.style.height = tallest[Math.floor(data[i])] + 'px';
      }
    });
  }
};
var pwrap;

// Simple templating function
w.applyTemplate = function (temp, data) {
  var newText = temp;
  for (var nme in data) {
    var newtext = data[nme] || "";
    if (typeof newtext == 'function') {
      newtext = '';
    }
    newText = newText.replace(new RegExp('{{' + nme + '}}', 'g'), newtext);
  }
  return newText;
};

/*var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
function getextraletters(num) {
    num = String(num)
    lastDigit = parseInt(num.charAt(num.length-1));
    switch (lastDigit) {
        case 1:
            return num + "st"
            break;
        case 2:
            if(num.length > 1 && parseInt(num.charAt(num.length-2)) == '1') {
                return num + "th";
            } else {
                return num + "nd";
            }
            break;
        case 3:
            if(num.length > 1 && parseInt(num.charAt(num.length-2)) == '1') {
                return num + "th";
            } else {
                return num + "rd";
            }
            break;
        default:
            return num + "th"
            break;
    }
}*/

var displaycookiePrefs = function displaycookiePrefs() {
  var prefarr = cprefs.length == 4 ? cprefs : [cver, '1', '1', '1'];
  var cb = qs('.cookiebar');
  var cookiecont = "<div id=\"cprefs\">\n<h3>Cookie controls</h3>\n<p>You can control which cookies you allow, we use 4 types of cookies</p>\n<div class=\"cpref\"><label for=\"cn\"><span>Necessary: <span class=\"ipop icon info vert\" title=\"These are required and cannot be turned off\"></span></span><span class=\"switch\"><input type=\"checkbox\" checked disabled id=\"cn\" value=\"1\" /><span class=\"slider\"></span></span></label></div>\n<div class=\"cpref\"><label for=\"cp\"><span>Performance: <span class=\"ipop icon info vert\" title=\"Site use analysis\"></span></span><span class=\"switch\"><input type=\"checkbox\" ".concat(prefarr[1] == '1' ? 'checked' : '', " id=\"cp\" value=\"1\" /><span class=\"slider\"></span></span></label></div>\n<div class=\"cpref\"><label for=\"cf\"><span>Functionality: <span class=\"icon info vert ipop\" title=\"Online Chat and Google Shopping Guarantee\"></span></span><span class=\"switch\"><input type=\"checkbox\" ").concat(prefarr[2] == '1' ? 'checked' : '', " id=\"cf\" value=\"1\" /><span class=\"slider\"></span></span></label></div>\n<div class=\"cpref\"><label for=\"cad\"><span>Advertising: <span class=\"icon info vert ipop\" title=\"Advertising tracking\"></span></span><span class=\"switch\"><input type=\"checkbox\" ").concat(prefarr[3] == '1' ? 'checked' : '', " id=\"cad\" value=\"1\" /><span class=\"slider\"></span></span></label></div>\n<div class=\"right\"><a class=\"btn\" id=\"csbtn\">Save</a></div></div>");
  var activateCookieForm = function activateCookieForm() {
    var csbtn = qs('#csbtn');
    csbtn.addEventListener('click', function () {
      var ccont = qs('#cprefs');
      var p = qs('#cp', ccont).checked ? 1 : 0;
      var f = qs('#cf', ccont).checked ? 1 : 0;
      var ad = qs('#cad', ccont).checked ? 1 : 0;
      cprefs = [cver, p, f, ad];
      document.cookie = "cookienotified=".concat(cprefs.join(','), "; path=/; expires=Thu, 31 Dec 2099 23:59:59;samesite=lax");
      if (cb) {
        cb.parentNode.removeChild(cb);
      }
      if (typeof cabox != 'undefined') {
        cabox.closeBox();
      }
      if (p) {
        funcCook();
        gtag('consent', 'update', {
          'analytics_storage': 'granted'
        });
        window.uetq.push('consent', 'update', {
          'ad_storage': 'granted'
        });
      } else {
        gtag('consent', 'update', {
          'analytics_storage': 'denied'
        });
        window.uetq.push('consent', 'update', {
          'ad_storage': 'denied'
        });
      }
      if (ad) {
        gtag('consent', 'update', {
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted'
        });
      } else {
        gtag('consent', 'update', {
          'ad_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied'
        });
      }
      if (f) {
        optionalFunc();
      }
    });
  };
  var cookiediv = qs('#ccustom');
  if (cb) {
    var o = {
      content: cookiecont,
      maxwidth: '340px',
      onComplete: function onComplete() {
        for (var i = 0; i < w.caboxPoppedFunctions.length; i++) {
          w.caboxPoppedFunctions[i]();
        }
        activateCookieForm();
      }
    };
    cabox.init(null, o);
  } else {
    cookiediv.innerHTML = cookiecont;
    activateCookieForm();
  }
  ipopSetup('#cprefs');
};

// Get query string parameters
w.getParameterByName = function (name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

// Scroll to element that matches selector
w.scrollToSel = function (sel) {
  st = window.pageYOffset;
  var n = typeof sel == 'string' ? qs(sel) : sel;
  var pos = n.getBoundingClientRect();
  var nph = qs('.navplaceholder');
  if (nph) {
    var navoff = nph.getBoundingClientRect();
    if (navoff.top < pos.top) {
      pos.top -= nph.offsetHeight;
    }
  }
  var targettop = pos.top + st;
  var fixedheights = 0;
  var stickys = qa('.stky');
  fe(stickys, function (a) {
    var ppos = a.parentNode.getBoundingClientRect();
    if ((a.classList.contains('fixbottom') ? ppos.bottom : ppos.top) + st < targettop) {
      fixedheights += a.closest('.actions') ? 70 : a.offsetHeight;
    }
  });
  targettop -= fixedheights;
  goToScrollTop(targettop);
};

// Animate scroll to position
var goToScrollTop = function goToScrollTop(tgt) {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({
      top: tgt,
      left: 0,
      behavior: 'auto'
    });
  } else {
    window.scrollTo(0, tgt);
  }
};
var goToScrollLeft = function goToScrollLeft(el, tgt) {
  if ('scrollBehavior' in el.style) {
    el.scrollLeft = tgt;
  } else if (el.scrollTo) {
    el.scrollTo({
      left: tgt,
      behavior: 'auto'
    });
  } else {
    el.scrollLeft = tgt;
  }
};

//Get index of element within it's parent
w.index = function (el) {
  return Array.from(el.parentNode.children).indexOf(el);
};
// Get element height even if hidden
var getElHeight = function getElHeight(el) {
  if (el.offsetHeight > 0) {
    return el.offsetHeight;
  } else {
    var els = el.currentStyle || window.getComputedStyle(el);
    var oldStyle = {
      height: els.height,
      overflow: els.overflow,
      display: els.display
    };
    Object.assign(el.style, {
      height: '0px',
      overflow: 'hidden',
      display: 'block'
    });
    var height = el.scrollHeight;
    var maxHeight = parseFloat(els.maxHeight.replace('px', ''));
    if (height > maxHeight) {
      height = maxHeight;
    }
    Object.assign(el.style, oldStyle);
    return height;
  }
};

// Slide in and out functions
var slideDownTime;
var lastSlideDown;
var lastSlideEl;
w.slideDown = function (el, time, callback) {
  var tgt = getElHeight(el);
  Object.assign(el.style, {
    overflow: 'hidden',
    height: '0px',
    display: 'block',
    transition: 'height 0.1s ease-in-out'
  });
  el.offsetHeight;
  el.style.height = tgt + 'px';
  lastSlideDown = function lastSlideDown() {
    Object.assign(el.style, {
      overflow: '',
      height: '',
      transition: ''
    });
    if (callback) {
      callback();
    }
  };
  if (slideDownTime && lastSlideEl == el) {
    clearTimeout(slideDownTime);
    lastSlideDown();
  }
  if (slideUpTime && lastSlideEl == el) {
    clearTimeout(slideUpTime);
    lastSlideUp();
  }
  lastSlideEl = el;
  setTimeout(lastSlideDown, time || 100);
};
var slideUpTime;
var lastSlideUp;
w.slideUp = function (el, time, callback) {
  var tgt = getElHeight(el);
  Object.assign(el.style, {
    overflow: 'hidden',
    height: tgt + 'px',
    transition: 'height 0.1s linear'
  });
  el.offsetHeight;
  el.style.height = '0px';
  lastSlideUp = function lastSlideUp() {
    Object.assign(el.style, {
      overflow: '',
      height: '',
      transition: '',
      display: 'none'
    });
    if (callback) {
      callback();
    }
  };
  if (slideDownTime && lastSlideEl == el) {
    clearTimeout(slideDownTime);
    lastSlideDown();
  }
  if (slideUpTime && lastSlideEl == el) {
    clearTimeout(slideUpTime);
    lastSlideUp();
  }
  lastSlideEl = el;
  setTimeout(lastSlideUp, time || 100);
};

// Fade in and out features
var fadeTimers = [];
var timerID = 0;
w.fadeOut = function (n, t, c) {
  if (fadeTimers && ds(n, 'timerID')) {
    clearTimeout(fadeTimers[ds(n, 'timerID')]);
  }
  n.classList.add('fadeIn', 'fadeReady');
  timerID++;
  ds(n, 'timerID', timerID);
  setTimeout(function () {
    n.classList.remove('fadeIn');
  }, 0);
  fadeTimers[timerID] = setTimeout(function () {
    n.style.display = 'none';
    n.classList.remove('fadeReady');
    if (c) {
      c();
    }
  }, t || 100);
};
w.fadeIn = function (n, t, c) {
  if (fadeTimers && ds(n, 'timerID')) {
    clearTimeout(fadeTimers[ds(n, 'timerID')]);
  }
  if (!n.classList.contains('fadeReady')) {
    n.classList.add('fadeReady');
  }
  n.style.display = 'block';
  timerID++;
  ds(n, 'timerID', timerID);
  setTimeout(function () {
    n.classList.add('fadeIn');
  }, 0);
  fadeTimers[timerID] = setTimeout(function () {
    n.classList.remove('fadeIn');
    n.classList.remove('fadeReady');
    if (c) {
      c();
    }
  }, t || 100);
};

// Form to json
w.serializeObject = function (form) {
  var obj = {};
  ap.slice.call(form.elements).forEach(function (field) {
    if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
    if (field.type === 'select-multiple') {
      var options = [];
      ap.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        options.push(option.value);
      });
      if (options.length) {
        obj[field.name] = options;
      }
      return;
    }
    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
    if (field.name.indexOf('[]') > -1) {
      if (obj[field.name]) {
        obj[field.name].push(field.value);
      } else {
        obj[field.name] = [field.value];
      }
    } else {
      obj[field.name] = field.value;
    }
  });
  return obj;
};
w.loadJS = function (url, implementationCode, location) {
  //url is URL of external file, implementationCode is the code
  //to be called from the file, location is the location to 
  //insert the <script> element

  var scriptTag = document.createElement('script');
  var urlMatch = url.match(/(\/?)assets\/shop\/js\/([a-zA-Z0-9\.]+).js/);
  if (urlMatch) {
    scriptTag.src = "".concat(urlMatch[1], "assets/shop/js/").concat(legacy).concat(urlMatch[2], ".js");
  } else {
    scriptTag.src = url;
  }
  if (implementationCode) {
    scriptTag.onload = implementationCode;
    scriptTag.onreadystatechange = implementationCode;
  }
  if (!location) {
    document.head.appendChild(scriptTag);
  } else {
    location.appendChild(scriptTag);
  }
};

// Product rendering functions

w.specids = [];
var mainimg = '<a href="{{url}}" onclick="prodC({{product_id}},this,\'Image Link Button\');"><div class="img-frame"><img src="{{src}}" alt="Image of {{alt}}" width="142" height="158" loading="lazy" /></div></a>';
var rrpsave = function rrpsave(o, n, l, v) {
  return "<div class=\"rrpsave exvat\"><div>".concat(l, ":<br /><span class=\"rrp_price\">&pound;").concat(currencyPad(o), "</span></div><div>SAVE:<br /><span class=\"save_price\">&pound;").concat(currencyPad(o - n), "</span></div></div><div class=\"rrpsave incvat\"><div>").concat(l, ":<br /><span class=\"rrp_price\">&pound;").concat(currencyPad(o * v), "</span></div><div>SAVE:<br /><span class=\"save_price\">&pound;").concat(currencyPad(o * v - n * v), "</span></div></div>");
};
w.populateProduct = function (p, n) {
  var loader = qs('.loader', n);
  if (loader) {
    loader.parentNode.removeChild(loader);
  }
  if (!n.querySelector('.img')) {
    var s = document.createDocumentFragment();
    if (p.manufacturer_id != 209) {
      p.product_name = p.manufacturer_name + ' ' + p.product_name;
    }
    var img = document.createElement('div');
    img.className = 'img';
    var pi = p.primary_image;
    if (Array.isArray(pi)) {
      pi = pi[0];
    }
    img.innerHTML = applyTemplate(mainimg, {
      url: p.url,
      product_name: p.product_name,
      product_id: p.product_id,
      src: pi && pi.medium_thumb_url ? pi.medium_thumb_url : '/images/sorry-no-image-available.gif',
      alt: pi ? p.product_name : 'Sorry no image available'
    });
    s.appendChild(img);
    var pp;
    var pwrslg = '';
    switch (p.product_power_supply) {
      case "Plug in":
        pwrslg = '13-amp';
        break;
      case "Plug in & Hardwired":
        pwrslg = 'electric-plug';
        break;
      case "Natural Gas":
        pwrslg = 'natural-gas';
        break;
      case "Propane Gas":
        pwrslg = 'lpg-propane';
        break;
      case "Dual Fuel":
        pwrslg = 'dual-fuel';
        break;
      case "Battery":
        pwrslg = 'battery';
        break;
      case "Rechargable Battery":
      case "Rechargeable Battery":
        pwrslg = 'battery-rechargable';
        break;
      case "Single Phase 16 Amp Commando Plug":
      case "3 Pin Commando Plug":
        pwrslg = 'commando-plug';
        break;
      case "5 Pin Commando Plug":
        pwrslg = '5-pin-commando-plug';
        break;
      case "3 Phase":
      case "Hardwired":
        pwrslg = 'electric';
        break;
    }
    if (pwrslg != '') {
      pp = document.createElement('img');
      pp.src = asc + '/shop/img/ps-' + pwrslg + '.svg';
      pp.alt = pp.title = p.product_power_supply.replace('Plug in', 'Standard Plug');
      pp.loading = 'lazy';
      pp.width = pp.height = 60;
      pp.className = 'pwr';
      img.appendChild(pp);
    }
    var availclass = "nostock";
    var iconclass = 'nostockicon';
    var stocktext = p.product_stock;
    switch (p.product_stock) {
      case "In Stock":
        availclass = "stock";
        iconclass = 'stockicon';
        break;
      case "Out of Stock (Due Soon)":
        if (p.product_stock_leadtime_days) {
          availclass = "preorder colour";
          iconclass = 'preorder colour';
          stocktext = "Order Now";
        } else {
          availclass = "preorder";
          iconclass = 'preorder';
          stocktext = "Pre-order";
        }
        break;
    }
    var stck = document.createElement('div');
    stck.classList.add('stkho');
    stck.innerHTML = '<span class="' + iconclass + ' icon"></span><span class="' + availclass + '">' + stocktext + (p.delivery_flags && p.delivery_flags.store_collection ? '<span class="icon-cac icon" title="Available for click and collect"></span>' : '') + '</span>';
    if (iconclass.indexOf('preorder') > -1 && p.product_stock_date) {
      var availtext = document.createElement('div');
      availtext.className = "availtext";
      var availdate = p.product_stock_date.split('-').reverse();
      availtext.textContent = 'Dispatch from ' + availdate.join('/');
      stck.appendChild(availtext);
    }

    /*if(availclass == 'stock' && p.next_day_delivery) {
      const nxtday = document.createElement('div');
      nxtday.innerHTML = applyTemplate('<div class="clearspace"></div><a href="{{url}}" onclick="prodC({{product_id}},this,\' View this Product link\', \'Get tomorrow\');"><img src="'+asc+'/shop/img/{{fndd}}next-day-delivery-icon.webp" srcset="'+asc+'/shop/img/{{fndd}}next-day-delivery-icon_hr.webp 2x" loading="lazy" alt="{{tfndd}}Next day delivery available" class="ndd" /></a>',{url:p.url,product_name:p.product_name,product_id:p.product_id,tfndd:(p.next_day_delivery_free?'Free ':''),fndd:(p.next_day_delivery_free?'free-':'')});
      stck.appendChild(nxtday);
    }*/

    var noManLogo = [209, 248, 156, 193];
    var losl = document.createElement('div');
    losl.className = 'statuslogos';
    var manp = document.createElement('div');
    if (noManLogo.indexOf(p.manufacturer_id) == -1) {
      var manlogpic = document.createElement('picture');
      var manlog = document.createElement('img');
      manlog.src = p.brand_logo_url;
      manlog.alt = p.manufacturer_name;
      manlog.className = 'brandlogo';
      manlog.loading = 'lazy';
      manlogpic.appendChild(manlog);
      manlog.width = p.manufacturer_logo_width;
      manlog.height = p.manufacturer_logo_height;
      manlog.style.width = p.manufacturer_logo_width + 'px';
      manlog.style.height = p.manufacturer_logo_height + 'px';
      manp.appendChild(manlogpic);
      losl.appendChild(manp);
    }
    if (p.special_offer_image && p.product_stock == 'In Stock' && n.className.indexOf('noc') == -1) {
      var so = document.createElement('div');
      so.className = 'infoitem';
      so.innerHTML = "<span class=\"infoitem\">".concat(p.special_offer_name.indexOf('World Cup') > -1 ? '<span class="icon-football icon"></span>' : '').concat(p.special_offer_name, "</span>");
      losl.appendChild(so);
    }
    var specs;
    var desc = document.createElement('div');
    desc.className = 'desc';
    if (p.specs && !p.product_specs_index) {
      p.product_specs_index = {};
      fe(p.specs, function (s) {
        p.product_specs_index[s.spec_id] = {
          "specification_name": s.spec_name,
          "display_text": s.value_string
        };
      });
    }
    if (p.product_specs_index) {
      specs = '<div class="specs">';
      var specCount = 0;
      var specsVals = [];
      if (typeof specids != 'undefined' && specids.length > 0) {
        specids.forEach(function (i) {
          var spec_val = p.product_specs_index[i];
          if (spec_val) {
            specsVals.push(spec_val);
          }
        });
      } else {
        fe(Object.keys(p.product_specs_index), function (key) {
          var spec_val = p.product_specs_index[key];
          if (spec_val) {
            specsVals.push(spec_val);
          }
        });
      }
      var exc = [{
        t: 'Height (External)',
        s: '(H)'
      }, {
        t: 'Length (External)',
        s: '(L)'
      }, {
        t: 'Width (External)',
        s: '(W)'
      }, {
        t: 'Depth (External)',
        s: '(D)'
      }, {
        t: 'Diameter',
        s: '(Ø)'
      }];
      var vardimcount = 0;
      var specdims = [];
      var unit = '';
      fe(specsVals, function (spec_val) {
        var s = exc.find(function (s) {
          return spec_val.specification_name == s.t;
        });
        if (s) {
          specdims.push(spec_val.display_text.replace(/Â/g, '&nbsp;').replace(/[^0-9]+$/g, '') + s.s);
          if (unit === '') {
            unit = spec_val.display_text.match(/([^0-9 ]+)$/);
          }
          if (spec_val.display_text === 'Various') {
            vardimcount++;
          }
        }
      });
      var sizeShown = false;
      fe(specsVals, function (spec_val) {
        if (exc.map(function (s) {
          return s.t;
        }).includes(spec_val.specification_name) && specdims.length > 0) {
          if (!sizeShown) {
            specs += "<div class=\"spec ui\"><strong>Dimensions:</strong> ".concat(vardimcount == specdims.length ? 'Various' : "".concat(specdims.join(' x ')).concat(unit && unit.length > 1 ? unit[1] : 'mm'), "</div>");
            specCount++;
            sizeShown = true;
          }
        } else if (spec_val.specification_name != 'Dimensions' || spec_val.specification_name == 'Dimensions' && specdims.length == 0) {
          specs += "<div class=\"spec ui\"><strong>".concat(spec_val.specification_name, ":</strong> ").concat(spec_val.display_text.replace(/Â/g, '&nbsp;'), "</div>");
          specCount++;
        }
      });
      specs += '</div>';
      desc.innerHTML = specs;
    } else {
      desc.innerHTML = '<div class="specs"></div>';
    }
    var avails = document.createElement('div');
    avails.className = 'avails';
    avails.appendChild(stck.cloneNode(true));
    var action = document.createElement('div');
    action.className = 'action';
    var lastdetail = document.createElement('div');
    lastdetail.className = 'lastdetails';
    if (p.product_stock != "Unavailable") {
      if (p.product_stock != 'Discontinued') {
        var offr = document.createElement('div');
        offr.className = 'offer cs';
        if (p.product_poa == 'Yes') {
          offr.innerHTML = '<p>Call to Order</p><a href="tel:01539 760 650" class="btn bbtn phonenumber"><strong>01539 760 650</strong></a>';
        } else {
          var offrhtml = '<div class="exvat"><strong>&pound;' + currencyPad(p.product_price) + '</strong> <span class="vattag">ex. VAT</span>';
          offrhtml += '</div><div class="incvat"><strong><span class="colour">&pound;' + currencyPad(p.product_price * (1 + Number(p.vat_rate_value))) + '</span></strong> <span class="vattag">inc. VAT</span>';
          offrhtml += '</div>';
          offr.innerHTML = offrhtml;
        }
        lastdetail.appendChild(offr);
      }
    }
    if (p.product_energy_rating && p.product_energy_rating != '') {
      var cateff = document.createElement('div');
      cateff.className = 'catefficiency';
      var cateffhtml = '';
      var o = {
        e: 'Energy Efficiency Rating'
      };
      if (p.product_energy_rating_range) {
        o.to = product_energy_rating_range.to;
        o.toc = o.to.replace(/\+/g, 'p');
        o.from = product_energy_rating_range.from;
        o.fromc = o.from.replace(/\+/g, p);
        cateffhtml = applyTemplate('<div><span class="enr rate{{fromc}}" title="{{e}}: {{from}}"><span>{{e}}: </span>{{from}}</span></a></div><div class="clearbit"></div><div class="smaller">to</div><div class="clearbit"></div><div><a href="{l}}"><span class="enr rate{{to}}" title="{{e}}: {{to}}"><span>{{e}}: </span>{{to}}</span></div>', o);
      } else {
        o.r = p.product_energy_rating;
        o.rc = o.r.replace(/\+/g, 'p');
        cateffhtml = applyTemplate('<span class="enr rate{{rc}}" title="{{e}}: {{r}}"><span>{{e}}: </span>{{r}}</span>', o);
      }
      cateff.innerHTML = cateffhtml;
      img.appendChild(cateff);
    }
    if (p.product_review_stars) {
      var rvw = document.createElement('div');
      rvw.className = 'reviews cs';
      rvw.innerHTML = "<a href=\"".concat(p.url, "#reviews\" class=\"icon-stars star").concat(p.product_review_stars * 2, "\" title=\"").concat(p.product_review_stars, " star reviewed\"><em><span></span></em></a>");
      lastdetail.appendChild(rvw);
    }
    /*if(p.graded_id && Number(p.product_price_new) < Number(p.graded_price)) {
      var gd = document.createElement('div');
      gd.className = 'padesc rrpsaveholder';
      gd.innerHTML = rrpsave(p.product_price_new, p.graded_price,'NEW',(1+Number(p.vat_rate_value)));
      lastdetail.appendChild(gd);
    }*/
    if (p.product_rrp > 0 && Number(p.product_rrp) > Number(p.product_price) && p.product_poa != "Yes" && p.product_stock != "Discontinued") {
      var prrp = document.createElement('div');
      prrp.className = 'padesc rrpsaveholder';
      prrp.innerHTML = rrpsave(p.product_rrp, p.product_price, 'RRP', 1 + Number(p.vat_rate_value));
      lastdetail.appendChild(prrp);
    }
    action.appendChild(stck);
    action.appendChild(lastdetail);
    var m = document.createDocumentFragment();
    m.appendChild(avails);
    m.appendChild(action);
    var ntitle = qs('.title', n);
    ntitle.appendChild(losl);
    ntitle.appendChild(desc);
    n.firstChild.insertBefore(s, n.firstChild.firstChild);
    n.firstChild.appendChild(m);
    n.classList.add('popt');
  }
};
w.setupIncrementors = function (selector) {
  var incrementors = qa(selector + ' .incrementor');
  fe(incrementors, function (incs) {
    var incsinp = qs('input', incs);
    if (!incsinp.classList.contains('scripted')) {
      incsinp.classList.add('scripted');
      var minus = document.createElement('span');
      minus.className = 'minusinput';
      minus.textContent = '-';
      var plus = document.createElement('span');
      plus.className = 'plusinput';
      plus.textContent = '+';
      incsinp.insertAdjacentElement('beforebegin', minus);
      incsinp.insertAdjacentElement('afterend', plus);
      if (incsinp.type == 'number') {
        incsinp.type = 'text';
      }
      if (!incsinp.min) {
        incsinp.min = 0;
      }
      minus.addEventListener('click', function () {
        var newval = parseInt(incsinp.value);
        incsinp.value = Math.max(newval - 1, parseInt(incsinp.min));
        triggerEvent(incsinp, 'change');
        incsinp.blur();
      });
      plus.addEventListener('click', function () {
        var newval = parseInt(incsinp.value);
        incsinp.value = Math.max(newval + 1);
        triggerEvent(incsinp, 'change');
        incsinp.blur();
      });
      incsinp.addEventListener('keypress', function (e) {
        return e.charCode >= 48 && e.charCode <= 57;
      });
      incsinp.addEventListener('change', function (e) {
        incsinp.value = parseInt(incsinp.value.replace(/\D/g, '') || 0);
      });
    }
  });
};
scriptReady = true;
if (pageReady && cssReady) {
  activatePage();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    if (pageReady && cssReady) {
      activatePage();
    } else {
      var actpageint = setInterval(function () {
        if (pageReady && cssReady) {
          clearInterval(actpageint);
          activatePage();
        }
      }, 50);
    }
  });
}
if (pageLoaded) {
  pageLoadComplete();
} else {
  window.addEventListener('load', pageLoadComplete);
}